
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2ac4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2ac4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7KPjv", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => (parcelRequire("7Cgyi")).popperGenerator);
$parcel$export(module.exports, "detectOverflow", () => (parcelRequire("fZpB1")).default);
$parcel$export(module.exports, "createPopperBase", () => (parcelRequire("7Cgyi")).createPopper);
$parcel$export(module.exports, "createPopper", () => (parcelRequire("5E3Mr")).createPopper);
$parcel$export(module.exports, "createPopperLite", () => (parcelRequire("jciLk")).createPopper);

var $jLrzS = parcelRequire("jLrzS");

var $aeXXa = parcelRequire("aeXXa");

var $7Cgyi = parcelRequire("7Cgyi");
var $fZpB1 = parcelRequire("fZpB1");

var $5E3Mr = parcelRequire("5E3Mr");

var $jciLk = parcelRequire("jciLk");
$parcel$exportWildcard(module.exports, $jLrzS);
$parcel$exportWildcard(module.exports, $aeXXa);

});
parcelRegister("jLrzS", function(module, exports) {

$parcel$export(module.exports, "top", () => $e637cc7076a8ce0e$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $e637cc7076a8ce0e$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $e637cc7076a8ce0e$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $e637cc7076a8ce0e$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $e637cc7076a8ce0e$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $e637cc7076a8ce0e$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $e637cc7076a8ce0e$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $e637cc7076a8ce0e$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $e637cc7076a8ce0e$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $e637cc7076a8ce0e$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $e637cc7076a8ce0e$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $e637cc7076a8ce0e$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $e637cc7076a8ce0e$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $e637cc7076a8ce0e$export$803cd8101b6c182b);
$parcel$export(module.exports, "beforeRead", () => $e637cc7076a8ce0e$export$421679a7c3d56e);
$parcel$export(module.exports, "read", () => $e637cc7076a8ce0e$export$aafa59e2e03f2942);
$parcel$export(module.exports, "afterRead", () => $e637cc7076a8ce0e$export$6964f6c886723980);
$parcel$export(module.exports, "beforeMain", () => $e637cc7076a8ce0e$export$c65e99957a05207c);
$parcel$export(module.exports, "main", () => $e637cc7076a8ce0e$export$f22da7240b7add18);
$parcel$export(module.exports, "afterMain", () => $e637cc7076a8ce0e$export$bab79516f2d662fe);
$parcel$export(module.exports, "beforeWrite", () => $e637cc7076a8ce0e$export$8d4d2d70e7d46032);
$parcel$export(module.exports, "write", () => $e637cc7076a8ce0e$export$68d8715fc104d294);
$parcel$export(module.exports, "afterWrite", () => $e637cc7076a8ce0e$export$70a6e5159acce2e6);
$parcel$export(module.exports, "modifierPhases", () => $e637cc7076a8ce0e$export$d087d3878fdf71d5);
var $e637cc7076a8ce0e$export$1e95b668f3b82d = 'top';
var $e637cc7076a8ce0e$export$40e543e69a8b3fbb = 'bottom';
var $e637cc7076a8ce0e$export$79ffe56a765070d2 = 'right';
var $e637cc7076a8ce0e$export$eabcd2c8791e7bf4 = 'left';
var $e637cc7076a8ce0e$export$dfb5619354ba860 = 'auto';
var $e637cc7076a8ce0e$export$aec2ce47c367b8c3 = [
    $e637cc7076a8ce0e$export$1e95b668f3b82d,
    $e637cc7076a8ce0e$export$40e543e69a8b3fbb,
    $e637cc7076a8ce0e$export$79ffe56a765070d2,
    $e637cc7076a8ce0e$export$eabcd2c8791e7bf4
];
var $e637cc7076a8ce0e$export$b3571188c770cc5a = 'start';
var $e637cc7076a8ce0e$export$bd5df0f255a350f8 = 'end';
var $e637cc7076a8ce0e$export$390fd549c5303b4d = 'clippingParents';
var $e637cc7076a8ce0e$export$d7b7311ec04a3e8f = 'viewport';
var $e637cc7076a8ce0e$export$ae5ab1c730825774 = 'popper';
var $e637cc7076a8ce0e$export$ca50aac9f3ba507f = 'reference';
var $e637cc7076a8ce0e$export$368f9a87e87fa4e1 = /*#__PURE__*/ $e637cc7076a8ce0e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $e637cc7076a8ce0e$export$b3571188c770cc5a,
        placement + "-" + $e637cc7076a8ce0e$export$bd5df0f255a350f8
    ]);
}, []);
var $e637cc7076a8ce0e$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($e637cc7076a8ce0e$export$aec2ce47c367b8c3, [
    $e637cc7076a8ce0e$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $e637cc7076a8ce0e$export$b3571188c770cc5a,
        placement + "-" + $e637cc7076a8ce0e$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $e637cc7076a8ce0e$export$421679a7c3d56e = 'beforeRead';
var $e637cc7076a8ce0e$export$aafa59e2e03f2942 = 'read';
var $e637cc7076a8ce0e$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $e637cc7076a8ce0e$export$c65e99957a05207c = 'beforeMain';
var $e637cc7076a8ce0e$export$f22da7240b7add18 = 'main';
var $e637cc7076a8ce0e$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $e637cc7076a8ce0e$export$8d4d2d70e7d46032 = 'beforeWrite';
var $e637cc7076a8ce0e$export$68d8715fc104d294 = 'write';
var $e637cc7076a8ce0e$export$70a6e5159acce2e6 = 'afterWrite';
var $e637cc7076a8ce0e$export$d087d3878fdf71d5 = [
    $e637cc7076a8ce0e$export$421679a7c3d56e,
    $e637cc7076a8ce0e$export$aafa59e2e03f2942,
    $e637cc7076a8ce0e$export$6964f6c886723980,
    $e637cc7076a8ce0e$export$c65e99957a05207c,
    $e637cc7076a8ce0e$export$f22da7240b7add18,
    $e637cc7076a8ce0e$export$bab79516f2d662fe,
    $e637cc7076a8ce0e$export$8d4d2d70e7d46032,
    $e637cc7076a8ce0e$export$68d8715fc104d294,
    $e637cc7076a8ce0e$export$70a6e5159acce2e6
];

});

parcelRegister("aeXXa", function(module, exports) {

$parcel$export(module.exports, "applyStyles", () => (parcelRequire("1giKJ")).default);
$parcel$export(module.exports, "arrow", () => (parcelRequire("3WjAC")).default);
$parcel$export(module.exports, "computeStyles", () => (parcelRequire("5MYEz")).default);
$parcel$export(module.exports, "eventListeners", () => (parcelRequire("rzgPX")).default);
$parcel$export(module.exports, "flip", () => (parcelRequire("hEpEE")).default);
$parcel$export(module.exports, "hide", () => (parcelRequire("6wxur")).default);
$parcel$export(module.exports, "offset", () => (parcelRequire("763v1")).default);
$parcel$export(module.exports, "popperOffsets", () => (parcelRequire("dIsBG")).default);
$parcel$export(module.exports, "preventOverflow", () => (parcelRequire("k6DeY")).default);

var $1giKJ = parcelRequire("1giKJ");

var $3WjAC = parcelRequire("3WjAC");

var $5MYEz = parcelRequire("5MYEz");

var $rzgPX = parcelRequire("rzgPX");

var $hEpEE = parcelRequire("hEpEE");

var $6wxur = parcelRequire("6wxur");

var $763v1 = parcelRequire("763v1");

var $dIsBG = parcelRequire("dIsBG");

var $k6DeY = parcelRequire("k6DeY");

});
parcelRegister("1giKJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb5d4f8f3afe249$export$2e2bcd8739ae039);

var $1AtEt = parcelRequire("1AtEt");

var $elMCC = parcelRequire("elMCC");
// and applies them to the HTMLElements such as popper and arrow
function $0eb5d4f8f3afe249$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $elMCC.isHTMLElement)(element) || !(0, $1AtEt.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $0eb5d4f8f3afe249$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $elMCC.isHTMLElement)(element) || !(0, $1AtEt.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $0eb5d4f8f3afe249$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $0eb5d4f8f3afe249$var$applyStyles,
    effect: $0eb5d4f8f3afe249$var$effect,
    requires: [
        'computeStyles'
    ]
};

});
parcelRegister("1AtEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $12802773e5d30df3$export$2e2bcd8739ae039);
function $12802773e5d30df3$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("elMCC", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $a728be20b93888b0$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $a728be20b93888b0$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $a728be20b93888b0$export$af51f0f06c0f328a);

var $9fyKd = parcelRequire("9fyKd");
function $a728be20b93888b0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $9fyKd.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $a728be20b93888b0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $9fyKd.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $a728be20b93888b0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $9fyKd.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("9fyKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc07749947592a8$export$2e2bcd8739ae039);
function $6bc07749947592a8$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("3WjAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2de5fbf4eb47f917$export$2e2bcd8739ae039);

var $60Lao = parcelRequire("60Lao");

var $8w55s = parcelRequire("8w55s");

var $8asxI = parcelRequire("8asxI");

var $kLfli = parcelRequire("kLfli");

var $gcLYC = parcelRequire("gcLYC");

var $bTCHc = parcelRequire("bTCHc");

var $lQCn7 = parcelRequire("lQCn7");

var $kN4dp = parcelRequire("kN4dp");

var $jLrzS = parcelRequire("jLrzS");
var $2de5fbf4eb47f917$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $lQCn7.default)(typeof padding !== 'number' ? padding : (0, $kN4dp.default)(padding, (0, $jLrzS.basePlacements)));
};
function $2de5fbf4eb47f917$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $60Lao.default)(state.placement);
    var axis = (0, $gcLYC.default)(basePlacement);
    var isVertical = [
        (0, $jLrzS.left),
        (0, $jLrzS.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $2de5fbf4eb47f917$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $8w55s.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $jLrzS.top) : (0, $jLrzS.left);
    var maxProp = axis === 'y' ? (0, $jLrzS.bottom) : (0, $jLrzS.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $kLfli.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $bTCHc.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $2de5fbf4eb47f917$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8asxI.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $2de5fbf4eb47f917$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $2de5fbf4eb47f917$var$arrow,
    effect: $2de5fbf4eb47f917$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});
parcelRegister("60Lao", function(module, exports) {

$parcel$export(module.exports, "default", () => $460754730025edf3$export$2e2bcd8739ae039);

function $460754730025edf3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("8w55s", function(module, exports) {

$parcel$export(module.exports, "default", () => $6335420ee03a175a$export$2e2bcd8739ae039);

var $jG7VP = parcelRequire("jG7VP");
function $6335420ee03a175a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $jG7VP.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("jG7VP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e53817a2a806cf93$export$2e2bcd8739ae039);

var $elMCC = parcelRequire("elMCC");

var $6F2w3 = parcelRequire("6F2w3");

var $9fyKd = parcelRequire("9fyKd");

var $kLh1L = parcelRequire("kLh1L");
function $e53817a2a806cf93$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $elMCC.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $6F2w3.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $6F2w3.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $elMCC.isElement)(element) ? (0, $9fyKd.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $kLh1L.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("6F2w3", function(module, exports) {

$parcel$export(module.exports, "max", () => $4d98860515abfc28$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $4d98860515abfc28$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $4d98860515abfc28$export$2077e0241d6afd3c);
var $4d98860515abfc28$export$8960430cfd85939f = Math.max;
var $4d98860515abfc28$export$96ec731ed4dcb222 = Math.min;
var $4d98860515abfc28$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("kLh1L", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1d567b9ff8c83d4$export$2e2bcd8739ae039);

var $hUg01 = parcelRequire("hUg01");
function $f1d567b9ff8c83d4$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $hUg01.default)());
}

});
parcelRegister("hUg01", function(module, exports) {

$parcel$export(module.exports, "default", () => $d09413c3eb33a9db$export$2e2bcd8739ae039);
function $d09413c3eb33a9db$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});




parcelRegister("8asxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2565e3b3777f15$export$2e2bcd8739ae039);

var $elMCC = parcelRequire("elMCC");
function $5f2565e3b3777f15$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $elMCC.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("kLfli", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1d4191c0b8a62bf$export$2e2bcd8739ae039);

var $9fyKd = parcelRequire("9fyKd");

var $1AtEt = parcelRequire("1AtEt");

var $3OQzR = parcelRequire("3OQzR");

var $elMCC = parcelRequire("elMCC");

var $6kHR6 = parcelRequire("6kHR6");

var $34FB4 = parcelRequire("34FB4");

var $hUg01 = parcelRequire("hUg01");
function $f1d4191c0b8a62bf$var$getTrueOffsetParent(element) {
    if (!(0, $elMCC.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3OQzR.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $f1d4191c0b8a62bf$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $hUg01.default)());
    var isIE = /Trident/i.test((0, $hUg01.default)());
    if (isIE && (0, $elMCC.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3OQzR.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $34FB4.default)(element);
    if ((0, $elMCC.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $elMCC.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $1AtEt.default)(currentNode)) < 0){
        var css = (0, $3OQzR.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $f1d4191c0b8a62bf$export$2e2bcd8739ae039(element) {
    var window = (0, $9fyKd.default)(element);
    var offsetParent = $f1d4191c0b8a62bf$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6kHR6.default)(offsetParent) && (0, $3OQzR.default)(offsetParent).position === 'static')offsetParent = $f1d4191c0b8a62bf$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $1AtEt.default)(offsetParent) === 'html' || (0, $1AtEt.default)(offsetParent) === 'body' && (0, $3OQzR.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $f1d4191c0b8a62bf$var$getContainingBlock(element) || window;
}

});
parcelRegister("3OQzR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7ed35ca1171845$export$2e2bcd8739ae039);

var $9fyKd = parcelRequire("9fyKd");
function $2c7ed35ca1171845$export$2e2bcd8739ae039(element) {
    return (0, $9fyKd.default)(element).getComputedStyle(element);
}

});

parcelRegister("6kHR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $49c6a11f692fac56$export$2e2bcd8739ae039);

var $1AtEt = parcelRequire("1AtEt");
function $49c6a11f692fac56$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $1AtEt.default)(element)) >= 0;
}

});

parcelRegister("34FB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $23d2031bfef85aa0$export$2e2bcd8739ae039);

var $1AtEt = parcelRequire("1AtEt");

var $eoZI2 = parcelRequire("eoZI2");

var $elMCC = parcelRequire("elMCC");
function $23d2031bfef85aa0$export$2e2bcd8739ae039(element) {
    if ((0, $1AtEt.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $elMCC.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $eoZI2.default)(element) // fallback
    );
}

});
parcelRegister("eoZI2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7c32cc782610d0c$export$2e2bcd8739ae039);

var $elMCC = parcelRequire("elMCC");
function $a7c32cc782610d0c$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $elMCC.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("gcLYC", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc2fb7bf3928b4f$export$2e2bcd8739ae039);
function $bcc2fb7bf3928b4f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("bTCHc", function(module, exports) {

$parcel$export(module.exports, "within", () => $8a92d8f28815e7f4$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $8a92d8f28815e7f4$export$86c8af6d3ef0b4a);

var $6F2w3 = parcelRequire("6F2w3");
function $8a92d8f28815e7f4$export$f28d906d67a997f3(min, value, max) {
    return (0, $6F2w3.max)(min, (0, $6F2w3.min)(value, max));
}
function $8a92d8f28815e7f4$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $8a92d8f28815e7f4$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("lQCn7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe7c38267f309d4c$export$2e2bcd8739ae039);

var $8wC61 = parcelRequire("8wC61");
function $fe7c38267f309d4c$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $8wC61.default)(), paddingObject);
}

});
parcelRegister("8wC61", function(module, exports) {

$parcel$export(module.exports, "default", () => $634edcf8ab280456$export$2e2bcd8739ae039);
function $634edcf8ab280456$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("kN4dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f22ba7554f8e03c1$export$2e2bcd8739ae039);
function $f22ba7554f8e03c1$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("5MYEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $43707bf2ad5c30be$export$2e2bcd8739ae039);

var $jLrzS = parcelRequire("jLrzS");

var $kLfli = parcelRequire("kLfli");

var $9fyKd = parcelRequire("9fyKd");

var $eoZI2 = parcelRequire("eoZI2");

var $3OQzR = parcelRequire("3OQzR");

var $60Lao = parcelRequire("60Lao");

var $joRDB = parcelRequire("joRDB");

var $6F2w3 = parcelRequire("6F2w3");
var $43707bf2ad5c30be$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $43707bf2ad5c30be$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $6F2w3.round)(x * dpr) / dpr || 0,
        y: (0, $6F2w3.round)(y * dpr) / dpr || 0
    };
}
function $43707bf2ad5c30be$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $jLrzS.left);
    var sideY = (0, $jLrzS.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $kLfli.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $9fyKd.default)(popper)) {
            offsetParent = (0, $eoZI2.default)(popper);
            if ((0, $3OQzR.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $jLrzS.top) || (placement === (0, $jLrzS.left) || placement === (0, $jLrzS.right)) && variation === (0, $jLrzS.end)) {
            sideY = (0, $jLrzS.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $jLrzS.left) || (placement === (0, $jLrzS.top) || placement === (0, $jLrzS.bottom)) && variation === (0, $jLrzS.end)) {
            sideX = (0, $jLrzS.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $43707bf2ad5c30be$var$unsetSides);
    var _ref4 = roundOffsets === true ? $43707bf2ad5c30be$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $9fyKd.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $43707bf2ad5c30be$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $60Lao.default)(state.placement),
        variation: (0, $joRDB.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $43707bf2ad5c30be$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $43707bf2ad5c30be$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $43707bf2ad5c30be$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $43707bf2ad5c30be$var$computeStyles,
    data: {}
};

});
parcelRegister("joRDB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f9dd91d6a8a896$export$2e2bcd8739ae039);
function $e1f9dd91d6a8a896$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});


parcelRegister("rzgPX", function(module, exports) {

$parcel$export(module.exports, "default", () => $052de1bb19c9463b$export$2e2bcd8739ae039);

var $9fyKd = parcelRequire("9fyKd");
var $052de1bb19c9463b$var$passive = {
    passive: true
};
function $052de1bb19c9463b$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $9fyKd.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $052de1bb19c9463b$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $052de1bb19c9463b$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $052de1bb19c9463b$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $052de1bb19c9463b$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $052de1bb19c9463b$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $052de1bb19c9463b$var$effect,
    data: {}
};

});

parcelRegister("hEpEE", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd9a1293f790e4b4$export$2e2bcd8739ae039);

var $1gDVx = parcelRequire("1gDVx");

var $60Lao = parcelRequire("60Lao");

var $271dc = parcelRequire("271dc");

var $fZpB1 = parcelRequire("fZpB1");

var $9tYSl = parcelRequire("9tYSl");

var $jLrzS = parcelRequire("jLrzS");

var $joRDB = parcelRequire("joRDB");
function $cd9a1293f790e4b4$var$getExpandedFallbackPlacements(placement) {
    if ((0, $60Lao.default)(placement) === (0, $jLrzS.auto)) return [];
    var oppositePlacement = (0, $1gDVx.default)(placement);
    return [
        (0, $271dc.default)(placement),
        oppositePlacement,
        (0, $271dc.default)(oppositePlacement)
    ];
}
function $cd9a1293f790e4b4$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $60Lao.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $1gDVx.default)(preferredPlacement)
    ] : $cd9a1293f790e4b4$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $60Lao.default)(placement) === (0, $jLrzS.auto) ? (0, $9tYSl.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $60Lao.default)(placement);
        var isStartVariation = (0, $joRDB.default)(placement) === (0, $jLrzS.start);
        var isVertical = [
            (0, $jLrzS.top),
            (0, $jLrzS.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $fZpB1.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $jLrzS.right) : (0, $jLrzS.left) : isStartVariation ? (0, $jLrzS.bottom) : (0, $jLrzS.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $1gDVx.default)(mainVariationSide);
        var altVariationSide = (0, $1gDVx.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cd9a1293f790e4b4$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cd9a1293f790e4b4$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("1gDVx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ec641b9be563b3b$export$2e2bcd8739ae039);
var $0ec641b9be563b3b$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $0ec641b9be563b3b$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $0ec641b9be563b3b$var$hash[matched];
    });
}

});

parcelRegister("271dc", function(module, exports) {

$parcel$export(module.exports, "default", () => $189d2ce17e78d31d$export$2e2bcd8739ae039);
var $189d2ce17e78d31d$var$hash = {
    start: 'end',
    end: 'start'
};
function $189d2ce17e78d31d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $189d2ce17e78d31d$var$hash[matched];
    });
}

});

parcelRegister("fZpB1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba40685b3737a63b$export$2e2bcd8739ae039);

var $83RBw = parcelRequire("83RBw");

var $eoZI2 = parcelRequire("eoZI2");

var $jG7VP = parcelRequire("jG7VP");

var $jNvRu = parcelRequire("jNvRu");

var $alJ8K = parcelRequire("alJ8K");

var $jLrzS = parcelRequire("jLrzS");

var $elMCC = parcelRequire("elMCC");

var $lQCn7 = parcelRequire("lQCn7");

var $kN4dp = parcelRequire("kN4dp");
function $ba40685b3737a63b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $jLrzS.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $jLrzS.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $jLrzS.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $lQCn7.default)(typeof padding !== 'number' ? padding : (0, $kN4dp.default)(padding, (0, $jLrzS.basePlacements)));
    var altContext = elementContext === (0, $jLrzS.popper) ? (0, $jLrzS.reference) : (0, $jLrzS.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $83RBw.default)((0, $elMCC.isElement)(element) ? element : element.contextElement || (0, $eoZI2.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $jG7VP.default)(state.elements.reference);
    var popperOffsets = (0, $jNvRu.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $alJ8K.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $jLrzS.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $jLrzS.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $jLrzS.right),
                (0, $jLrzS.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $jLrzS.top),
                (0, $jLrzS.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("83RBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de82f38dadb0118$export$2e2bcd8739ae039);

var $jLrzS = parcelRequire("jLrzS");

var $jWcKe = parcelRequire("jWcKe");

var $aT5HR = parcelRequire("aT5HR");

var $20xQM = parcelRequire("20xQM");

var $kLfli = parcelRequire("kLfli");

var $eoZI2 = parcelRequire("eoZI2");

var $3OQzR = parcelRequire("3OQzR");

var $elMCC = parcelRequire("elMCC");

var $jG7VP = parcelRequire("jG7VP");

var $34FB4 = parcelRequire("34FB4");

var $8asxI = parcelRequire("8asxI");

var $1AtEt = parcelRequire("1AtEt");

var $alJ8K = parcelRequire("alJ8K");

var $6F2w3 = parcelRequire("6F2w3");
function $5de82f38dadb0118$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $jG7VP.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $5de82f38dadb0118$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $jLrzS.viewport) ? (0, $alJ8K.default)((0, $jWcKe.default)(element, strategy)) : (0, $elMCC.isElement)(clippingParent) ? $5de82f38dadb0118$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $alJ8K.default)((0, $aT5HR.default)((0, $eoZI2.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $5de82f38dadb0118$var$getClippingParents(element) {
    var clippingParents = (0, $20xQM.default)((0, $34FB4.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3OQzR.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $elMCC.isHTMLElement)(element) ? (0, $kLfli.default)(element) : element;
    if (!(0, $elMCC.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $elMCC.isElement)(clippingParent) && (0, $8asxI.default)(clippingParent, clipperElement) && (0, $1AtEt.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $5de82f38dadb0118$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $5de82f38dadb0118$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $5de82f38dadb0118$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $6F2w3.max)(rect.top, accRect.top);
        accRect.right = (0, $6F2w3.min)(rect.right, accRect.right);
        accRect.bottom = (0, $6F2w3.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $6F2w3.max)(rect.left, accRect.left);
        return accRect;
    }, $5de82f38dadb0118$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("jWcKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83d51e7c39601a4$export$2e2bcd8739ae039);

var $9fyKd = parcelRequire("9fyKd");

var $eoZI2 = parcelRequire("eoZI2");

var $9rhYi = parcelRequire("9rhYi");

var $kLh1L = parcelRequire("kLh1L");
function $e83d51e7c39601a4$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $9fyKd.default)(element);
    var html = (0, $eoZI2.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $kLh1L.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $9rhYi.default)(element),
        y: y
    };
}

});
parcelRegister("9rhYi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6df4936c9e193592$export$2e2bcd8739ae039);

var $jG7VP = parcelRequire("jG7VP");

var $eoZI2 = parcelRequire("eoZI2");

var $bxlum = parcelRequire("bxlum");
function $6df4936c9e193592$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $jG7VP.default)((0, $eoZI2.default)(element)).left + (0, $bxlum.default)(element).scrollLeft;
}

});
parcelRegister("bxlum", function(module, exports) {

$parcel$export(module.exports, "default", () => $866371f7e438d938$export$2e2bcd8739ae039);

var $9fyKd = parcelRequire("9fyKd");
function $866371f7e438d938$export$2e2bcd8739ae039(node) {
    var win = (0, $9fyKd.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("aT5HR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed377a38a96dedc$export$2e2bcd8739ae039);

var $eoZI2 = parcelRequire("eoZI2");

var $3OQzR = parcelRequire("3OQzR");

var $9rhYi = parcelRequire("9rhYi");

var $bxlum = parcelRequire("bxlum");

var $6F2w3 = parcelRequire("6F2w3");
function $7ed377a38a96dedc$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $eoZI2.default)(element);
    var winScroll = (0, $bxlum.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $6F2w3.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $6F2w3.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $9rhYi.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3OQzR.default)(body || html).direction === 'rtl') x += (0, $6F2w3.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("20xQM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1765d6d03e178d9c$export$2e2bcd8739ae039);

var $ckFNa = parcelRequire("ckFNa");

var $34FB4 = parcelRequire("34FB4");

var $9fyKd = parcelRequire("9fyKd");

var $3KWF9 = parcelRequire("3KWF9");
function $1765d6d03e178d9c$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $ckFNa.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $9fyKd.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $3KWF9.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1765d6d03e178d9c$export$2e2bcd8739ae039((0, $34FB4.default)(target)));
}

});
parcelRegister("ckFNa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa7c54c75b87ab4$export$2e2bcd8739ae039);

var $34FB4 = parcelRequire("34FB4");

var $3KWF9 = parcelRequire("3KWF9");

var $1AtEt = parcelRequire("1AtEt");

var $elMCC = parcelRequire("elMCC");
function $8fa7c54c75b87ab4$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $1AtEt.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $elMCC.isHTMLElement)(node) && (0, $3KWF9.default)(node)) return node;
    return $8fa7c54c75b87ab4$export$2e2bcd8739ae039((0, $34FB4.default)(node));
}

});
parcelRegister("3KWF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bc32c2a1dd648fc$export$2e2bcd8739ae039);

var $3OQzR = parcelRequire("3OQzR");
function $2bc32c2a1dd648fc$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3OQzR.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("alJ8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $788ee16afb92b8ba$export$2e2bcd8739ae039);
function $788ee16afb92b8ba$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("jNvRu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e69b4f05bf90e148$export$2e2bcd8739ae039);

var $60Lao = parcelRequire("60Lao");

var $joRDB = parcelRequire("joRDB");

var $gcLYC = parcelRequire("gcLYC");

var $jLrzS = parcelRequire("jLrzS");
function $e69b4f05bf90e148$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $60Lao.default)(placement) : null;
    var variation = placement ? (0, $joRDB.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $jLrzS.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $jLrzS.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $jLrzS.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $jLrzS.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $gcLYC.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $jLrzS.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $jLrzS.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("9tYSl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e760b178e898950$export$2e2bcd8739ae039);

var $joRDB = parcelRequire("joRDB");

var $jLrzS = parcelRequire("jLrzS");

var $fZpB1 = parcelRequire("fZpB1");

var $60Lao = parcelRequire("60Lao");
function $6e760b178e898950$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $jLrzS.placements) : _options$allowedAutoP;
    var variation = (0, $joRDB.default)(placement);
    var placements = variation ? flipVariations ? (0, $jLrzS.variationPlacements) : (0, $jLrzS.variationPlacements).filter(function(placement) {
        return (0, $joRDB.default)(placement) === variation;
    }) : (0, $jLrzS.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $fZpB1.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $60Lao.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("6wxur", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bffb5a6231bdf39$export$2e2bcd8739ae039);

var $jLrzS = parcelRequire("jLrzS");

var $fZpB1 = parcelRequire("fZpB1");
function $4bffb5a6231bdf39$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $4bffb5a6231bdf39$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $jLrzS.top),
        (0, $jLrzS.right),
        (0, $jLrzS.bottom),
        (0, $jLrzS.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $4bffb5a6231bdf39$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $fZpB1.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $fZpB1.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $4bffb5a6231bdf39$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $4bffb5a6231bdf39$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $4bffb5a6231bdf39$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $4bffb5a6231bdf39$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $4bffb5a6231bdf39$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $4bffb5a6231bdf39$var$hide
};

});

parcelRegister("763v1", function(module, exports) {

$parcel$export(module.exports, "default", () => $52abced383b71bca$export$2e2bcd8739ae039);

var $60Lao = parcelRequire("60Lao");

var $jLrzS = parcelRequire("jLrzS");
function $52abced383b71bca$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $60Lao.default)(placement);
    var invertDistance = [
        (0, $jLrzS.left),
        (0, $jLrzS.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $jLrzS.left),
        (0, $jLrzS.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $52abced383b71bca$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $jLrzS.placements).reduce(function(acc, placement) {
        acc[placement] = $52abced383b71bca$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $52abced383b71bca$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $52abced383b71bca$var$offset
};

});

parcelRegister("dIsBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc59327f04619f1$export$2e2bcd8739ae039);

var $jNvRu = parcelRequire("jNvRu");
function $9fc59327f04619f1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $jNvRu.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $9fc59327f04619f1$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $9fc59327f04619f1$var$popperOffsets,
    data: {}
};

});

parcelRegister("k6DeY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea32ce856be6220c$export$2e2bcd8739ae039);

var $jLrzS = parcelRequire("jLrzS");

var $60Lao = parcelRequire("60Lao");

var $gcLYC = parcelRequire("gcLYC");

var $gqBJN = parcelRequire("gqBJN");

var $bTCHc = parcelRequire("bTCHc");

var $8w55s = parcelRequire("8w55s");

var $kLfli = parcelRequire("kLfli");

var $fZpB1 = parcelRequire("fZpB1");

var $joRDB = parcelRequire("joRDB");

var $8wC61 = parcelRequire("8wC61");

var $6F2w3 = parcelRequire("6F2w3");
function $ea32ce856be6220c$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $fZpB1.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $60Lao.default)(state.placement);
    var variation = (0, $joRDB.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $gcLYC.default)(basePlacement);
    var altAxis = (0, $gqBJN.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $jLrzS.top) : (0, $jLrzS.left);
        var altSide = mainAxis === 'y' ? (0, $jLrzS.bottom) : (0, $jLrzS.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $jLrzS.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $jLrzS.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $8w55s.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $8wC61.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $bTCHc.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $kLfli.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $bTCHc.within)(tether ? (0, $6F2w3.min)(min, tetherMin) : min, offset, tether ? (0, $6F2w3.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $jLrzS.top) : (0, $jLrzS.left);
        var _altSide = mainAxis === 'x' ? (0, $jLrzS.bottom) : (0, $jLrzS.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $jLrzS.top),
            (0, $jLrzS.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $bTCHc.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $bTCHc.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ea32ce856be6220c$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $ea32ce856be6220c$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("gqBJN", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5c58f0b7b6ff1d$export$2e2bcd8739ae039);
function $bf5c58f0b7b6ff1d$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});



parcelRegister("7Cgyi", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $58b8ebea6e905680$export$ed5e13716264f202);
$parcel$export(module.exports, "createPopper", () => $58b8ebea6e905680$export$8f7491d57c8f97a9);

var $b6HbZ = parcelRequire("b6HbZ");

var $8w55s = parcelRequire("8w55s");

var $20xQM = parcelRequire("20xQM");

var $kLfli = parcelRequire("kLfli");

var $39l9P = parcelRequire("39l9P");

var $auI6s = parcelRequire("auI6s");

var $a2qga = parcelRequire("a2qga");

var $fZpB1 = parcelRequire("fZpB1");

var $elMCC = parcelRequire("elMCC");
var $58b8ebea6e905680$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $58b8ebea6e905680$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $58b8ebea6e905680$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $58b8ebea6e905680$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $58b8ebea6e905680$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $elMCC.isElement)(reference) ? (0, $20xQM.default)(reference) : reference.contextElement ? (0, $20xQM.default)(reference.contextElement) : [],
                    popper: (0, $20xQM.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $39l9P.default)((0, $a2qga.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$58b8ebea6e905680$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $b6HbZ.default)(reference, (0, $kLfli.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $8w55s.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $auI6s.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$58b8ebea6e905680$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $58b8ebea6e905680$export$8f7491d57c8f97a9 = /*#__PURE__*/ $58b8ebea6e905680$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("b6HbZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8161c259fea12a3c$export$2e2bcd8739ae039);

var $jG7VP = parcelRequire("jG7VP");

var $5nrlA = parcelRequire("5nrlA");

var $1AtEt = parcelRequire("1AtEt");

var $elMCC = parcelRequire("elMCC");

var $9rhYi = parcelRequire("9rhYi");

var $eoZI2 = parcelRequire("eoZI2");

var $3KWF9 = parcelRequire("3KWF9");

var $6F2w3 = parcelRequire("6F2w3");
function $8161c259fea12a3c$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $6F2w3.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $6F2w3.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $8161c259fea12a3c$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $elMCC.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $elMCC.isHTMLElement)(offsetParent) && $8161c259fea12a3c$var$isElementScaled(offsetParent);
    var documentElement = (0, $eoZI2.default)(offsetParent);
    var rect = (0, $jG7VP.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1AtEt.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $3KWF9.default)(documentElement)) scroll = (0, $5nrlA.default)(offsetParent);
        if ((0, $elMCC.isHTMLElement)(offsetParent)) {
            offsets = (0, $jG7VP.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $9rhYi.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("5nrlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ea4504d54823051$export$2e2bcd8739ae039);

var $bxlum = parcelRequire("bxlum");

var $9fyKd = parcelRequire("9fyKd");

var $elMCC = parcelRequire("elMCC");

var $2oIy9 = parcelRequire("2oIy9");
function $3ea4504d54823051$export$2e2bcd8739ae039(node) {
    if (node === (0, $9fyKd.default)(node) || !(0, $elMCC.isHTMLElement)(node)) return (0, $bxlum.default)(node);
    else return (0, $2oIy9.default)(node);
}

});
parcelRegister("2oIy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf061531cbc0d12$export$2e2bcd8739ae039);
function $1bf061531cbc0d12$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("39l9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $24b29fd27688b8c3$export$2e2bcd8739ae039);

var $jLrzS = parcelRequire("jLrzS");
function $24b29fd27688b8c3$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $24b29fd27688b8c3$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $24b29fd27688b8c3$var$order(modifiers); // order based on phase
    return (0, $jLrzS.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("auI6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a3eeaace4af8555$export$2e2bcd8739ae039);
function $7a3eeaace4af8555$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("a2qga", function(module, exports) {

$parcel$export(module.exports, "default", () => $74ee75eee40cba68$export$2e2bcd8739ae039);
function $74ee75eee40cba68$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("5E3Mr", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $41c39edb07ab29f1$export$8f7491d57c8f97a9);

var $7Cgyi = parcelRequire("7Cgyi");

var $rzgPX = parcelRequire("rzgPX");

var $dIsBG = parcelRequire("dIsBG");

var $5MYEz = parcelRequire("5MYEz");

var $1giKJ = parcelRequire("1giKJ");

var $763v1 = parcelRequire("763v1");

var $hEpEE = parcelRequire("hEpEE");

var $k6DeY = parcelRequire("k6DeY");

var $3WjAC = parcelRequire("3WjAC");

var $6wxur = parcelRequire("6wxur");


var $41c39edb07ab29f1$export$d34966752335dd47 = [
    (0, $rzgPX.default),
    (0, $dIsBG.default),
    (0, $5MYEz.default),
    (0, $1giKJ.default),
    (0, $763v1.default),
    (0, $hEpEE.default),
    (0, $k6DeY.default),
    (0, $3WjAC.default),
    (0, $6wxur.default)
];
var $41c39edb07ab29f1$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $7Cgyi.popperGenerator)({
    defaultModifiers: $41c39edb07ab29f1$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("jciLk", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $df9db11b6d214c4e$export$8f7491d57c8f97a9);

var $7Cgyi = parcelRequire("7Cgyi");

var $rzgPX = parcelRequire("rzgPX");

var $dIsBG = parcelRequire("dIsBG");

var $5MYEz = parcelRequire("5MYEz");

var $1giKJ = parcelRequire("1giKJ");
var $df9db11b6d214c4e$export$d34966752335dd47 = [
    (0, $rzgPX.default),
    (0, $dIsBG.default),
    (0, $5MYEz.default),
    (0, $1giKJ.default)
];
var $df9db11b6d214c4e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $7Cgyi.popperGenerator)({
    defaultModifiers: $df9db11b6d214c4e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});


var $ee0b3f147614cfc9$exports = {};
/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ 
!function(t, e) {
    $ee0b3f147614cfc9$exports = e((parcelRequire("7KPjv")));
}($ee0b3f147614cfc9$exports, function(t) {
    "use strict";
    function e(t) {
        const e = Object.create(null, {
            [Symbol.toStringTag]: {
                value: "Module"
            }
        });
        if (t) {
            for(const i in t)if ("default" !== i) {
                const s = Object.getOwnPropertyDescriptor(t, i);
                Object.defineProperty(e, i, s.get ? s : {
                    enumerable: !0,
                    get: ()=>t[i]
                });
            }
        }
        return e.default = t, Object.freeze(e);
    }
    const i = e(t), s = new Map, n = {
        set (t, e, i) {
            s.has(t) || s.set(t, new Map);
            const n = s.get(t);
            n.has(e) || 0 === n.size ? n.set(e, i) : console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(n.keys())[0]}.`);
        },
        get: (t, e)=>s.has(t) && s.get(t).get(e) || null,
        remove (t, e) {
            if (!s.has(t)) return;
            const i = s.get(t);
            i.delete(e), 0 === i.size && s.delete(t);
        }
    }, o = "transitionend", r = (t)=>(t && window.CSS && window.CSS.escape && (t = t.replace(/#([^\s"#']+)/g, (t, e)=>`#${CSS.escape(e)}`)), t), a = (t)=>null == t ? `${t}` : Object.prototype.toString.call(t).match(/\s([a-z]+)/i)[1].toLowerCase(), l = (t)=>{
        t.dispatchEvent(new Event(o));
    }, c = (t)=>!(!t || "object" != typeof t) && (void 0 !== t.jquery && (t = t[0]), void 0 !== t.nodeType), h = (t)=>c(t) ? t.jquery ? t[0] : t : "string" == typeof t && t.length > 0 ? document.querySelector(r(t)) : null, d = (t)=>{
        if (!c(t) || 0 === t.getClientRects().length) return !1;
        const e = "visible" === getComputedStyle(t).getPropertyValue("visibility"), i = t.closest("details:not([open])");
        if (!i) return e;
        if (i !== t) {
            const e = t.closest("summary");
            if (e && e.parentNode !== i) return !1;
            if (null === e) return !1;
        }
        return e;
    }, u = (t)=>!t || t.nodeType !== Node.ELEMENT_NODE || !!t.classList.contains("disabled") || (void 0 !== t.disabled ? t.disabled : t.hasAttribute("disabled") && "false" !== t.getAttribute("disabled")), _ = (t)=>{
        if (!document.documentElement.attachShadow) return null;
        if ("function" == typeof t.getRootNode) {
            const e = t.getRootNode();
            return e instanceof ShadowRoot ? e : null;
        }
        return t instanceof ShadowRoot ? t : t.parentNode ? _(t.parentNode) : null;
    }, g = ()=>{}, f = (t)=>{
        t.offsetHeight;
    }, m = ()=>window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, p = [], b = ()=>"rtl" === document.documentElement.dir, v = (t)=>{
        var e;
        e = ()=>{
            const e = m();
            if (e) {
                const i = t.NAME, s = e.fn[i];
                e.fn[i] = t.jQueryInterface, e.fn[i].Constructor = t, e.fn[i].noConflict = ()=>(e.fn[i] = s, t.jQueryInterface);
            }
        }, "loading" === document.readyState ? (p.length || document.addEventListener("DOMContentLoaded", ()=>{
            for (const t of p)t();
        }), p.push(e)) : e();
    }, y = (t, e = [], i = t)=>"function" == typeof t ? t.call(...e) : i, w = (t, e, i = !0)=>{
        if (!i) return void y(t);
        const s = ((t)=>{
            if (!t) return 0;
            let { transitionDuration: e, transitionDelay: i } = window.getComputedStyle(t);
            const s = Number.parseFloat(e), n = Number.parseFloat(i);
            return s || n ? (e = e.split(",")[0], i = i.split(",")[0], 1e3 * (Number.parseFloat(e) + Number.parseFloat(i))) : 0;
        })(e) + 5;
        let n = !1;
        const r = ({ target: i })=>{
            i === e && (n = !0, e.removeEventListener(o, r), y(t));
        };
        e.addEventListener(o, r), setTimeout(()=>{
            n || l(e);
        }, s);
    }, A = (t, e, i, s)=>{
        const n = t.length;
        let o = t.indexOf(e);
        return -1 === o ? !i && s ? t[n - 1] : t[0] : (o += i ? 1 : -1, s && (o = (o + n) % n), t[Math.max(0, Math.min(o, n - 1))]);
    }, E = /[^.]*(?=\..*)\.|.*/, C = /\..*/, T = /::\d+$/, k = {};
    let $ = 1;
    const S = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    }, L = new Set([
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll"
    ]);
    function O(t, e) {
        return e && `${e}::${$++}` || t.uidEvent || $++;
    }
    function I(t) {
        const e = O(t);
        return t.uidEvent = e, k[e] = k[e] || {}, k[e];
    }
    function D(t, e, i = null) {
        return Object.values(t).find((t)=>t.callable === e && t.delegationSelector === i);
    }
    function N(t, e, i) {
        const s = "string" == typeof e, n = s ? i : e || i;
        let o = j(t);
        return L.has(o) || (o = t), [
            s,
            n,
            o
        ];
    }
    function P(t, e, i, s, n) {
        if ("string" != typeof e || !t) return;
        let [o, r, a] = N(e, i, s);
        if (e in S) {
            const t = (t)=>function(e) {
                    if (!e.relatedTarget || e.relatedTarget !== e.delegateTarget && !e.delegateTarget.contains(e.relatedTarget)) return t.call(this, e);
                };
            r = t(r);
        }
        const l = I(t), c = l[a] || (l[a] = {}), h = D(c, r, o ? i : null);
        if (h) return void (h.oneOff = h.oneOff && n);
        const d = O(r, e.replace(E, "")), u = o ? function(t, e, i) {
            return function s(n) {
                const o = t.querySelectorAll(e);
                for(let { target: r } = n; r && r !== this; r = r.parentNode)for (const a of o)if (a === r) return z(n, {
                    delegateTarget: r
                }), s.oneOff && F.off(t, n.type, e, i), i.apply(r, [
                    n
                ]);
            };
        }(t, i, r) : function(t, e) {
            return function i(s) {
                return z(s, {
                    delegateTarget: t
                }), i.oneOff && F.off(t, s.type, e), e.apply(t, [
                    s
                ]);
            };
        }(t, r);
        u.delegationSelector = o ? i : null, u.callable = r, u.oneOff = n, u.uidEvent = d, c[d] = u, t.addEventListener(a, u, o);
    }
    function x(t, e, i, s, n) {
        const o = D(e[i], s, n);
        o && (t.removeEventListener(i, o, Boolean(n)), delete e[i][o.uidEvent]);
    }
    function M(t, e, i, s) {
        const n = e[i] || {};
        for (const [o, r] of Object.entries(n))o.includes(s) && x(t, e, i, r.callable, r.delegationSelector);
    }
    function j(t) {
        return t = t.replace(C, ""), S[t] || t;
    }
    const F = {
        on (t, e, i, s) {
            P(t, e, i, s, !1);
        },
        one (t, e, i, s) {
            P(t, e, i, s, !0);
        },
        off (t, e, i, s) {
            if ("string" != typeof e || !t) return;
            const [n, o, r] = N(e, i, s), a = r !== e, l = I(t), c = l[r] || {}, h = e.startsWith(".");
            if (void 0 === o) {
                if (h) for (const i of Object.keys(l))M(t, l, i, e.slice(1));
                for (const [i, s] of Object.entries(c)){
                    const n = i.replace(T, "");
                    a && !e.includes(n) || x(t, l, r, s.callable, s.delegationSelector);
                }
            } else {
                if (!Object.keys(c).length) return;
                x(t, l, r, o, n ? i : null);
            }
        },
        trigger (t, e, i) {
            if ("string" != typeof e || !t) return null;
            const s = m();
            let n = null, o = !0, r = !0, a = !1;
            e !== j(e) && s && (n = s.Event(e, i), s(t).trigger(n), o = !n.isPropagationStopped(), r = !n.isImmediatePropagationStopped(), a = n.isDefaultPrevented());
            const l = z(new Event(e, {
                bubbles: o,
                cancelable: !0
            }), i);
            return a && l.preventDefault(), r && t.dispatchEvent(l), l.defaultPrevented && n && n.preventDefault(), l;
        }
    };
    function z(t, e = {}) {
        for (const [i, s] of Object.entries(e))try {
            t[i] = s;
        } catch (e) {
            Object.defineProperty(t, i, {
                configurable: !0,
                get: ()=>s
            });
        }
        return t;
    }
    function H(t) {
        if ("true" === t) return !0;
        if ("false" === t) return !1;
        if (t === Number(t).toString()) return Number(t);
        if ("" === t || "null" === t) return null;
        if ("string" != typeof t) return t;
        try {
            return JSON.parse(decodeURIComponent(t));
        } catch (e) {
            return t;
        }
    }
    function B(t) {
        return t.replace(/[A-Z]/g, (t)=>`-${t.toLowerCase()}`);
    }
    const q = {
        setDataAttribute (t, e, i) {
            t.setAttribute(`data-bs-${B(e)}`, i);
        },
        removeDataAttribute (t, e) {
            t.removeAttribute(`data-bs-${B(e)}`);
        },
        getDataAttributes (t) {
            if (!t) return {};
            const e = {}, i = Object.keys(t.dataset).filter((t)=>t.startsWith("bs") && !t.startsWith("bsConfig"));
            for (const s of i){
                let i = s.replace(/^bs/, "");
                i = i.charAt(0).toLowerCase() + i.slice(1), e[i] = H(t.dataset[s]);
            }
            return e;
        },
        getDataAttribute: (t, e)=>H(t.getAttribute(`data-bs-${B(e)}`))
    };
    class W {
        static get Default() {
            return {};
        }
        static get DefaultType() {
            return {};
        }
        static get NAME() {
            throw new Error('You have to implement the static method "NAME", for each component!');
        }
        _getConfig(t) {
            return t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
        }
        _configAfterMerge(t) {
            return t;
        }
        _mergeConfigObj(t, e) {
            const i = c(e) ? q.getDataAttribute(e, "config") : {};
            return {
                ...this.constructor.Default,
                ..."object" == typeof i ? i : {},
                ...c(e) ? q.getDataAttributes(e) : {},
                ..."object" == typeof t ? t : {}
            };
        }
        _typeCheckConfig(t, e = this.constructor.DefaultType) {
            for (const [i, s] of Object.entries(e)){
                const e = t[i], n = c(e) ? "element" : a(e);
                if (!new RegExp(s).test(n)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${i}" provided type "${n}" but expected type "${s}".`);
            }
        }
    }
    class R extends W {
        constructor(t, e){
            super(), (t = h(t)) && (this._element = t, this._config = this._getConfig(e), n.set(this._element, this.constructor.DATA_KEY, this));
        }
        dispose() {
            n.remove(this._element, this.constructor.DATA_KEY), F.off(this._element, this.constructor.EVENT_KEY);
            for (const t of Object.getOwnPropertyNames(this))this[t] = null;
        }
        _queueCallback(t, e, i = !0) {
            w(t, e, i);
        }
        _getConfig(t) {
            return t = this._mergeConfigObj(t, this._element), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
        }
        static getInstance(t) {
            return n.get(h(t), this.DATA_KEY);
        }
        static getOrCreateInstance(t, e = {}) {
            return this.getInstance(t) || new this(t, "object" == typeof e ? e : null);
        }
        static get VERSION() {
            return "5.3.8";
        }
        static get DATA_KEY() {
            return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
            return `.${this.DATA_KEY}`;
        }
        static eventName(t) {
            return `${t}${this.EVENT_KEY}`;
        }
    }
    const K = (t)=>{
        let e = t.getAttribute("data-bs-target");
        if (!e || "#" === e) {
            let i = t.getAttribute("href");
            if (!i || !i.includes("#") && !i.startsWith(".")) return null;
            i.includes("#") && !i.startsWith("#") && (i = `#${i.split("#")[1]}`), e = i && "#" !== i ? i.trim() : null;
        }
        return e ? e.split(",").map((t)=>r(t)).join(",") : null;
    }, V = {
        find: (t, e = document.documentElement)=>[].concat(...Element.prototype.querySelectorAll.call(e, t)),
        findOne: (t, e = document.documentElement)=>Element.prototype.querySelector.call(e, t),
        children: (t, e)=>[].concat(...t.children).filter((t)=>t.matches(e)),
        parents (t, e) {
            const i = [];
            let s = t.parentNode.closest(e);
            for(; s;)i.push(s), s = s.parentNode.closest(e);
            return i;
        },
        prev (t, e) {
            let i = t.previousElementSibling;
            for(; i;){
                if (i.matches(e)) return [
                    i
                ];
                i = i.previousElementSibling;
            }
            return [];
        },
        next (t, e) {
            let i = t.nextElementSibling;
            for(; i;){
                if (i.matches(e)) return [
                    i
                ];
                i = i.nextElementSibling;
            }
            return [];
        },
        focusableChildren (t) {
            const e = [
                "a",
                "button",
                "input",
                "textarea",
                "select",
                "details",
                "[tabindex]",
                '[contenteditable="true"]'
            ].map((t)=>`${t}:not([tabindex^="-"])`).join(",");
            return this.find(e, t).filter((t)=>!u(t) && d(t));
        },
        getSelectorFromElement (t) {
            const e = K(t);
            return e && V.findOne(e) ? e : null;
        },
        getElementFromSelector (t) {
            const e = K(t);
            return e ? V.findOne(e) : null;
        },
        getMultipleElementsFromSelector (t) {
            const e = K(t);
            return e ? V.find(e) : [];
        }
    }, Q = (t, e = "hide")=>{
        const i = `click.dismiss${t.EVENT_KEY}`, s = t.NAME;
        F.on(document, i, `[data-bs-dismiss="${s}"]`, function(i) {
            if ([
                "A",
                "AREA"
            ].includes(this.tagName) && i.preventDefault(), u(this)) return;
            const n = V.getElementFromSelector(this) || this.closest(`.${s}`);
            t.getOrCreateInstance(n)[e]();
        });
    }, X = ".bs.alert", Y = `close${X}`, U = `closed${X}`;
    class G extends R {
        static get NAME() {
            return "alert";
        }
        close() {
            if (F.trigger(this._element, Y).defaultPrevented) return;
            this._element.classList.remove("show");
            const t = this._element.classList.contains("fade");
            this._queueCallback(()=>this._destroyElement(), this._element, t);
        }
        _destroyElement() {
            this._element.remove(), F.trigger(this._element, U), this.dispose();
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = G.getOrCreateInstance(this);
                if ("string" == typeof t) {
                    if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError(`No method named "${t}"`);
                    e[t](this);
                }
            });
        }
    }
    Q(G, "close"), v(G);
    const J = '[data-bs-toggle="button"]';
    class Z extends R {
        static get NAME() {
            return "button";
        }
        toggle() {
            this._element.setAttribute("aria-pressed", this._element.classList.toggle("active"));
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = Z.getOrCreateInstance(this);
                "toggle" === t && e[t]();
            });
        }
    }
    F.on(document, "click.bs.button.data-api", J, (t)=>{
        t.preventDefault();
        const e = t.target.closest(J);
        Z.getOrCreateInstance(e).toggle();
    }), v(Z);
    const tt = ".bs.swipe", et = `touchstart${tt}`, it = `touchmove${tt}`, st = `touchend${tt}`, nt = `pointerdown${tt}`, ot = `pointerup${tt}`, rt = {
        endCallback: null,
        leftCallback: null,
        rightCallback: null
    }, at = {
        endCallback: "(function|null)",
        leftCallback: "(function|null)",
        rightCallback: "(function|null)"
    };
    class lt extends W {
        constructor(t, e){
            super(), this._element = t, t && lt.isSupported() && (this._config = this._getConfig(e), this._deltaX = 0, this._supportPointerEvents = Boolean(window.PointerEvent), this._initEvents());
        }
        static get Default() {
            return rt;
        }
        static get DefaultType() {
            return at;
        }
        static get NAME() {
            return "swipe";
        }
        dispose() {
            F.off(this._element, tt);
        }
        _start(t) {
            this._supportPointerEvents ? this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX) : this._deltaX = t.touches[0].clientX;
        }
        _end(t) {
            this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX - this._deltaX), this._handleSwipe(), y(this._config.endCallback);
        }
        _move(t) {
            this._deltaX = t.touches && t.touches.length > 1 ? 0 : t.touches[0].clientX - this._deltaX;
        }
        _handleSwipe() {
            const t = Math.abs(this._deltaX);
            if (t <= 40) return;
            const e = t / this._deltaX;
            this._deltaX = 0, e && y(e > 0 ? this._config.rightCallback : this._config.leftCallback);
        }
        _initEvents() {
            this._supportPointerEvents ? (F.on(this._element, nt, (t)=>this._start(t)), F.on(this._element, ot, (t)=>this._end(t)), this._element.classList.add("pointer-event")) : (F.on(this._element, et, (t)=>this._start(t)), F.on(this._element, it, (t)=>this._move(t)), F.on(this._element, st, (t)=>this._end(t)));
        }
        _eventIsPointerPenTouch(t) {
            return this._supportPointerEvents && ("pen" === t.pointerType || "touch" === t.pointerType);
        }
        static isSupported() {
            return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
        }
    }
    const ct = ".bs.carousel", ht = ".data-api", dt = "ArrowLeft", ut = "ArrowRight", _t = "next", gt = "prev", ft = "left", mt = "right", pt = `slide${ct}`, bt = `slid${ct}`, vt = `keydown${ct}`, yt = `mouseenter${ct}`, wt = `mouseleave${ct}`, At = `dragstart${ct}`, Et = `load${ct}${ht}`, Ct = `click${ct}${ht}`, Tt = "carousel", kt = "active", $t = ".active", St = ".carousel-item", Lt = $t + St, Ot = {
        [dt]: mt,
        [ut]: ft
    }, It = {
        interval: 5e3,
        keyboard: !0,
        pause: "hover",
        ride: !1,
        touch: !0,
        wrap: !0
    }, Dt = {
        interval: "(number|boolean)",
        keyboard: "boolean",
        pause: "(string|boolean)",
        ride: "(boolean|string)",
        touch: "boolean",
        wrap: "boolean"
    };
    class Nt extends R {
        constructor(t, e){
            super(t, e), this._interval = null, this._activeElement = null, this._isSliding = !1, this.touchTimeout = null, this._swipeHelper = null, this._indicatorsElement = V.findOne(".carousel-indicators", this._element), this._addEventListeners(), this._config.ride === Tt && this.cycle();
        }
        static get Default() {
            return It;
        }
        static get DefaultType() {
            return Dt;
        }
        static get NAME() {
            return "carousel";
        }
        next() {
            this._slide(_t);
        }
        nextWhenVisible() {
            !document.hidden && d(this._element) && this.next();
        }
        prev() {
            this._slide(gt);
        }
        pause() {
            this._isSliding && l(this._element), this._clearInterval();
        }
        cycle() {
            this._clearInterval(), this._updateInterval(), this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
        }
        _maybeEnableCycle() {
            this._config.ride && (this._isSliding ? F.one(this._element, bt, ()=>this.cycle()) : this.cycle());
        }
        to(t) {
            const e = this._getItems();
            if (t > e.length - 1 || t < 0) return;
            if (this._isSliding) return void F.one(this._element, bt, ()=>this.to(t));
            const i = this._getItemIndex(this._getActive());
            if (i === t) return;
            const s = t > i ? _t : gt;
            this._slide(s, e[t]);
        }
        dispose() {
            this._swipeHelper && this._swipeHelper.dispose(), super.dispose();
        }
        _configAfterMerge(t) {
            return t.defaultInterval = t.interval, t;
        }
        _addEventListeners() {
            this._config.keyboard && F.on(this._element, vt, (t)=>this._keydown(t)), "hover" === this._config.pause && (F.on(this._element, yt, ()=>this.pause()), F.on(this._element, wt, ()=>this._maybeEnableCycle())), this._config.touch && lt.isSupported() && this._addTouchEventListeners();
        }
        _addTouchEventListeners() {
            for (const t of V.find(".carousel-item img", this._element))F.on(t, At, (t)=>t.preventDefault());
            const t = {
                leftCallback: ()=>this._slide(this._directionToOrder(ft)),
                rightCallback: ()=>this._slide(this._directionToOrder(mt)),
                endCallback: ()=>{
                    "hover" === this._config.pause && (this.pause(), this.touchTimeout && clearTimeout(this.touchTimeout), this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), 500 + this._config.interval));
                }
            };
            this._swipeHelper = new lt(this._element, t);
        }
        _keydown(t) {
            if (/input|textarea/i.test(t.target.tagName)) return;
            const e = Ot[t.key];
            e && (t.preventDefault(), this._slide(this._directionToOrder(e)));
        }
        _getItemIndex(t) {
            return this._getItems().indexOf(t);
        }
        _setActiveIndicatorElement(t) {
            if (!this._indicatorsElement) return;
            const e = V.findOne($t, this._indicatorsElement);
            e.classList.remove(kt), e.removeAttribute("aria-current");
            const i = V.findOne(`[data-bs-slide-to="${t}"]`, this._indicatorsElement);
            i && (i.classList.add(kt), i.setAttribute("aria-current", "true"));
        }
        _updateInterval() {
            const t = this._activeElement || this._getActive();
            if (!t) return;
            const e = Number.parseInt(t.getAttribute("data-bs-interval"), 10);
            this._config.interval = e || this._config.defaultInterval;
        }
        _slide(t, e = null) {
            if (this._isSliding) return;
            const i = this._getActive(), s = t === _t, n = e || A(this._getItems(), i, s, this._config.wrap);
            if (n === i) return;
            const o = this._getItemIndex(n), r = (e)=>F.trigger(this._element, e, {
                    relatedTarget: n,
                    direction: this._orderToDirection(t),
                    from: this._getItemIndex(i),
                    to: o
                });
            if (r(pt).defaultPrevented) return;
            if (!i || !n) return;
            const a = Boolean(this._interval);
            this.pause(), this._isSliding = !0, this._setActiveIndicatorElement(o), this._activeElement = n;
            const l = s ? "carousel-item-start" : "carousel-item-end", c = s ? "carousel-item-next" : "carousel-item-prev";
            n.classList.add(c), f(n), i.classList.add(l), n.classList.add(l), this._queueCallback(()=>{
                n.classList.remove(l, c), n.classList.add(kt), i.classList.remove(kt, c, l), this._isSliding = !1, r(bt);
            }, i, this._isAnimated()), a && this.cycle();
        }
        _isAnimated() {
            return this._element.classList.contains("slide");
        }
        _getActive() {
            return V.findOne(Lt, this._element);
        }
        _getItems() {
            return V.find(St, this._element);
        }
        _clearInterval() {
            this._interval && (clearInterval(this._interval), this._interval = null);
        }
        _directionToOrder(t) {
            return b() ? t === ft ? gt : _t : t === ft ? _t : gt;
        }
        _orderToDirection(t) {
            return b() ? t === gt ? ft : mt : t === gt ? mt : ft;
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = Nt.getOrCreateInstance(this, t);
                if ("number" != typeof t) {
                    if ("string" == typeof t) {
                        if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError(`No method named "${t}"`);
                        e[t]();
                    }
                } else e.to(t);
            });
        }
    }
    F.on(document, Ct, "[data-bs-slide], [data-bs-slide-to]", function(t) {
        const e = V.getElementFromSelector(this);
        if (!e || !e.classList.contains(Tt)) return;
        t.preventDefault();
        const i = Nt.getOrCreateInstance(e), s = this.getAttribute("data-bs-slide-to");
        return s ? (i.to(s), void i._maybeEnableCycle()) : "next" === q.getDataAttribute(this, "slide") ? (i.next(), void i._maybeEnableCycle()) : (i.prev(), void i._maybeEnableCycle());
    }), F.on(window, Et, ()=>{
        const t = V.find('[data-bs-ride="carousel"]');
        for (const e of t)Nt.getOrCreateInstance(e);
    }), v(Nt);
    const Pt = ".bs.collapse", xt = `show${Pt}`, Mt = `shown${Pt}`, jt = `hide${Pt}`, Ft = `hidden${Pt}`, zt = `click${Pt}.data-api`, Ht = "show", Bt = "collapse", qt = "collapsing", Wt = `:scope .${Bt} .${Bt}`, Rt = '[data-bs-toggle="collapse"]', Kt = {
        parent: null,
        toggle: !0
    }, Vt = {
        parent: "(null|element)",
        toggle: "boolean"
    };
    class Qt extends R {
        constructor(t, e){
            super(t, e), this._isTransitioning = !1, this._triggerArray = [];
            const i = V.find(Rt);
            for (const t of i){
                const e = V.getSelectorFromElement(t), i = V.find(e).filter((t)=>t === this._element);
                null !== e && i.length && this._triggerArray.push(t);
            }
            this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle();
        }
        static get Default() {
            return Kt;
        }
        static get DefaultType() {
            return Vt;
        }
        static get NAME() {
            return "collapse";
        }
        toggle() {
            this._isShown() ? this.hide() : this.show();
        }
        show() {
            if (this._isTransitioning || this._isShown()) return;
            let t = [];
            if (this._config.parent && (t = this._getFirstLevelChildren(".collapse.show, .collapse.collapsing").filter((t)=>t !== this._element).map((t)=>Qt.getOrCreateInstance(t, {
                    toggle: !1
                }))), t.length && t[0]._isTransitioning) return;
            if (F.trigger(this._element, xt).defaultPrevented) return;
            for (const e of t)e.hide();
            const e = this._getDimension();
            this._element.classList.remove(Bt), this._element.classList.add(qt), this._element.style[e] = 0, this._addAriaAndCollapsedClass(this._triggerArray, !0), this._isTransitioning = !0;
            const i = `scroll${e[0].toUpperCase() + e.slice(1)}`;
            this._queueCallback(()=>{
                this._isTransitioning = !1, this._element.classList.remove(qt), this._element.classList.add(Bt, Ht), this._element.style[e] = "", F.trigger(this._element, Mt);
            }, this._element, !0), this._element.style[e] = `${this._element[i]}px`;
        }
        hide() {
            if (this._isTransitioning || !this._isShown()) return;
            if (F.trigger(this._element, jt).defaultPrevented) return;
            const t = this._getDimension();
            this._element.style[t] = `${this._element.getBoundingClientRect()[t]}px`, f(this._element), this._element.classList.add(qt), this._element.classList.remove(Bt, Ht);
            for (const t of this._triggerArray){
                const e = V.getElementFromSelector(t);
                e && !this._isShown(e) && this._addAriaAndCollapsedClass([
                    t
                ], !1);
            }
            this._isTransitioning = !0, this._element.style[t] = "", this._queueCallback(()=>{
                this._isTransitioning = !1, this._element.classList.remove(qt), this._element.classList.add(Bt), F.trigger(this._element, Ft);
            }, this._element, !0);
        }
        _isShown(t = this._element) {
            return t.classList.contains(Ht);
        }
        _configAfterMerge(t) {
            return t.toggle = Boolean(t.toggle), t.parent = h(t.parent), t;
        }
        _getDimension() {
            return this._element.classList.contains("collapse-horizontal") ? "width" : "height";
        }
        _initializeChildren() {
            if (!this._config.parent) return;
            const t = this._getFirstLevelChildren(Rt);
            for (const e of t){
                const t = V.getElementFromSelector(e);
                t && this._addAriaAndCollapsedClass([
                    e
                ], this._isShown(t));
            }
        }
        _getFirstLevelChildren(t) {
            const e = V.find(Wt, this._config.parent);
            return V.find(t, this._config.parent).filter((t)=>!e.includes(t));
        }
        _addAriaAndCollapsedClass(t, e) {
            if (t.length) for (const i of t)i.classList.toggle("collapsed", !e), i.setAttribute("aria-expanded", e);
        }
        static jQueryInterface(t) {
            const e = {};
            return "string" == typeof t && /show|hide/.test(t) && (e.toggle = !1), this.each(function() {
                const i = Qt.getOrCreateInstance(this, e);
                if ("string" == typeof t) {
                    if (void 0 === i[t]) throw new TypeError(`No method named "${t}"`);
                    i[t]();
                }
            });
        }
    }
    F.on(document, zt, Rt, function(t) {
        ("A" === t.target.tagName || t.delegateTarget && "A" === t.delegateTarget.tagName) && t.preventDefault();
        for (const t of V.getMultipleElementsFromSelector(this))Qt.getOrCreateInstance(t, {
            toggle: !1
        }).toggle();
    }), v(Qt);
    const Xt = "dropdown", Yt = ".bs.dropdown", Ut = ".data-api", Gt = "ArrowUp", Jt = "ArrowDown", Zt = `hide${Yt}`, te = `hidden${Yt}`, ee = `show${Yt}`, ie = `shown${Yt}`, se = `click${Yt}${Ut}`, ne = `keydown${Yt}${Ut}`, oe = `keyup${Yt}${Ut}`, re = "show", ae = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)', le = `${ae}.${re}`, ce = ".dropdown-menu", he = b() ? "top-end" : "top-start", de = b() ? "top-start" : "top-end", ue = b() ? "bottom-end" : "bottom-start", _e = b() ? "bottom-start" : "bottom-end", ge = b() ? "left-start" : "right-start", fe = b() ? "right-start" : "left-start", me = {
        autoClose: !0,
        boundary: "clippingParents",
        display: "dynamic",
        offset: [
            0,
            2
        ],
        popperConfig: null,
        reference: "toggle"
    }, pe = {
        autoClose: "(boolean|string)",
        boundary: "(string|element)",
        display: "string",
        offset: "(array|string|function)",
        popperConfig: "(null|object|function)",
        reference: "(string|element|object)"
    };
    class be extends R {
        constructor(t, e){
            super(t, e), this._popper = null, this._parent = this._element.parentNode, this._menu = V.next(this._element, ce)[0] || V.prev(this._element, ce)[0] || V.findOne(ce, this._parent), this._inNavbar = this._detectNavbar();
        }
        static get Default() {
            return me;
        }
        static get DefaultType() {
            return pe;
        }
        static get NAME() {
            return Xt;
        }
        toggle() {
            return this._isShown() ? this.hide() : this.show();
        }
        show() {
            if (u(this._element) || this._isShown()) return;
            const t = {
                relatedTarget: this._element
            };
            if (!F.trigger(this._element, ee, t).defaultPrevented) {
                if (this._createPopper(), "ontouchstart" in document.documentElement && !this._parent.closest(".navbar-nav")) for (const t of [].concat(...document.body.children))F.on(t, "mouseover", g);
                this._element.focus(), this._element.setAttribute("aria-expanded", !0), this._menu.classList.add(re), this._element.classList.add(re), F.trigger(this._element, ie, t);
            }
        }
        hide() {
            if (u(this._element) || !this._isShown()) return;
            const t = {
                relatedTarget: this._element
            };
            this._completeHide(t);
        }
        dispose() {
            this._popper && this._popper.destroy(), super.dispose();
        }
        update() {
            this._inNavbar = this._detectNavbar(), this._popper && this._popper.update();
        }
        _completeHide(t) {
            if (!F.trigger(this._element, Zt, t).defaultPrevented) {
                if ("ontouchstart" in document.documentElement) for (const t of [].concat(...document.body.children))F.off(t, "mouseover", g);
                this._popper && this._popper.destroy(), this._menu.classList.remove(re), this._element.classList.remove(re), this._element.setAttribute("aria-expanded", "false"), q.removeDataAttribute(this._menu, "popper"), F.trigger(this._element, te, t);
            }
        }
        _getConfig(t) {
            if ("object" == typeof (t = super._getConfig(t)).reference && !c(t.reference) && "function" != typeof t.reference.getBoundingClientRect) throw new TypeError(`${Xt.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
            return t;
        }
        _createPopper() {
            if (void 0 === i) throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org/docs/v2/)");
            let t = this._element;
            "parent" === this._config.reference ? t = this._parent : c(this._config.reference) ? t = h(this._config.reference) : "object" == typeof this._config.reference && (t = this._config.reference);
            const e = this._getPopperConfig();
            this._popper = i.createPopper(t, this._menu, e);
        }
        _isShown() {
            return this._menu.classList.contains(re);
        }
        _getPlacement() {
            const t = this._parent;
            if (t.classList.contains("dropend")) return ge;
            if (t.classList.contains("dropstart")) return fe;
            if (t.classList.contains("dropup-center")) return "top";
            if (t.classList.contains("dropdown-center")) return "bottom";
            const e = "end" === getComputedStyle(this._menu).getPropertyValue("--bs-position").trim();
            return t.classList.contains("dropup") ? e ? de : he : e ? _e : ue;
        }
        _detectNavbar() {
            return null !== this._element.closest(".navbar");
        }
        _getOffset() {
            const { offset: t } = this._config;
            return "string" == typeof t ? t.split(",").map((t)=>Number.parseInt(t, 10)) : "function" == typeof t ? (e)=>t(e, this._element) : t;
        }
        _getPopperConfig() {
            const t = {
                placement: this._getPlacement(),
                modifiers: [
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: this._getOffset()
                        }
                    }
                ]
            };
            return (this._inNavbar || "static" === this._config.display) && (q.setDataAttribute(this._menu, "popper", "static"), t.modifiers = [
                {
                    name: "applyStyles",
                    enabled: !1
                }
            ]), {
                ...t,
                ...y(this._config.popperConfig, [
                    void 0,
                    t
                ])
            };
        }
        _selectMenuItem({ key: t, target: e }) {
            const i = V.find(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", this._menu).filter((t)=>d(t));
            i.length && A(i, e, t === Jt, !i.includes(e)).focus();
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = be.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t]();
                }
            });
        }
        static clearMenus(t) {
            if (2 === t.button || "keyup" === t.type && "Tab" !== t.key) return;
            const e = V.find(le);
            for (const i of e){
                const e = be.getInstance(i);
                if (!e || !1 === e._config.autoClose) continue;
                const s = t.composedPath(), n = s.includes(e._menu);
                if (s.includes(e._element) || "inside" === e._config.autoClose && !n || "outside" === e._config.autoClose && n) continue;
                if (e._menu.contains(t.target) && ("keyup" === t.type && "Tab" === t.key || /input|select|option|textarea|form/i.test(t.target.tagName))) continue;
                const o = {
                    relatedTarget: e._element
                };
                "click" === t.type && (o.clickEvent = t), e._completeHide(o);
            }
        }
        static dataApiKeydownHandler(t) {
            const e = /input|textarea/i.test(t.target.tagName), i = "Escape" === t.key, s = [
                Gt,
                Jt
            ].includes(t.key);
            if (!s && !i) return;
            if (e && !i) return;
            t.preventDefault();
            const n = this.matches(ae) ? this : V.prev(this, ae)[0] || V.next(this, ae)[0] || V.findOne(ae, t.delegateTarget.parentNode), o = be.getOrCreateInstance(n);
            if (s) return t.stopPropagation(), o.show(), void o._selectMenuItem(t);
            o._isShown() && (t.stopPropagation(), o.hide(), n.focus());
        }
    }
    F.on(document, ne, ae, be.dataApiKeydownHandler), F.on(document, ne, ce, be.dataApiKeydownHandler), F.on(document, se, be.clearMenus), F.on(document, oe, be.clearMenus), F.on(document, se, ae, function(t) {
        t.preventDefault(), be.getOrCreateInstance(this).toggle();
    }), v(be);
    const ve = "backdrop", ye = "show", we = `mousedown.bs.${ve}`, Ae = {
        className: "modal-backdrop",
        clickCallback: null,
        isAnimated: !1,
        isVisible: !0,
        rootElement: "body"
    }, Ee = {
        className: "string",
        clickCallback: "(function|null)",
        isAnimated: "boolean",
        isVisible: "boolean",
        rootElement: "(element|string)"
    };
    class Ce extends W {
        constructor(t){
            super(), this._config = this._getConfig(t), this._isAppended = !1, this._element = null;
        }
        static get Default() {
            return Ae;
        }
        static get DefaultType() {
            return Ee;
        }
        static get NAME() {
            return ve;
        }
        show(t) {
            if (!this._config.isVisible) return void y(t);
            this._append();
            const e = this._getElement();
            this._config.isAnimated && f(e), e.classList.add(ye), this._emulateAnimation(()=>{
                y(t);
            });
        }
        hide(t) {
            this._config.isVisible ? (this._getElement().classList.remove(ye), this._emulateAnimation(()=>{
                this.dispose(), y(t);
            })) : y(t);
        }
        dispose() {
            this._isAppended && (F.off(this._element, we), this._element.remove(), this._isAppended = !1);
        }
        _getElement() {
            if (!this._element) {
                const t = document.createElement("div");
                t.className = this._config.className, this._config.isAnimated && t.classList.add("fade"), this._element = t;
            }
            return this._element;
        }
        _configAfterMerge(t) {
            return t.rootElement = h(t.rootElement), t;
        }
        _append() {
            if (this._isAppended) return;
            const t = this._getElement();
            this._config.rootElement.append(t), F.on(t, we, ()=>{
                y(this._config.clickCallback);
            }), this._isAppended = !0;
        }
        _emulateAnimation(t) {
            w(t, this._getElement(), this._config.isAnimated);
        }
    }
    const Te = ".bs.focustrap", ke = `focusin${Te}`, $e = `keydown.tab${Te}`, Se = "backward", Le = {
        autofocus: !0,
        trapElement: null
    }, Oe = {
        autofocus: "boolean",
        trapElement: "element"
    };
    class Ie extends W {
        constructor(t){
            super(), this._config = this._getConfig(t), this._isActive = !1, this._lastTabNavDirection = null;
        }
        static get Default() {
            return Le;
        }
        static get DefaultType() {
            return Oe;
        }
        static get NAME() {
            return "focustrap";
        }
        activate() {
            this._isActive || (this._config.autofocus && this._config.trapElement.focus(), F.off(document, Te), F.on(document, ke, (t)=>this._handleFocusin(t)), F.on(document, $e, (t)=>this._handleKeydown(t)), this._isActive = !0);
        }
        deactivate() {
            this._isActive && (this._isActive = !1, F.off(document, Te));
        }
        _handleFocusin(t) {
            const { trapElement: e } = this._config;
            if (t.target === document || t.target === e || e.contains(t.target)) return;
            const i = V.focusableChildren(e);
            0 === i.length ? e.focus() : this._lastTabNavDirection === Se ? i[i.length - 1].focus() : i[0].focus();
        }
        _handleKeydown(t) {
            "Tab" === t.key && (this._lastTabNavDirection = t.shiftKey ? Se : "forward");
        }
    }
    const De = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", Ne = ".sticky-top", Pe = "padding-right", xe = "margin-right";
    class Me {
        constructor(){
            this._element = document.body;
        }
        getWidth() {
            const t = document.documentElement.clientWidth;
            return Math.abs(window.innerWidth - t);
        }
        hide() {
            const t = this.getWidth();
            this._disableOverFlow(), this._setElementAttributes(this._element, Pe, (e)=>e + t), this._setElementAttributes(De, Pe, (e)=>e + t), this._setElementAttributes(Ne, xe, (e)=>e - t);
        }
        reset() {
            this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, Pe), this._resetElementAttributes(De, Pe), this._resetElementAttributes(Ne, xe);
        }
        isOverflowing() {
            return this.getWidth() > 0;
        }
        _disableOverFlow() {
            this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
        }
        _setElementAttributes(t, e, i) {
            const s = this.getWidth();
            this._applyManipulationCallback(t, (t)=>{
                if (t !== this._element && window.innerWidth > t.clientWidth + s) return;
                this._saveInitialAttribute(t, e);
                const n = window.getComputedStyle(t).getPropertyValue(e);
                t.style.setProperty(e, `${i(Number.parseFloat(n))}px`);
            });
        }
        _saveInitialAttribute(t, e) {
            const i = t.style.getPropertyValue(e);
            i && q.setDataAttribute(t, e, i);
        }
        _resetElementAttributes(t, e) {
            this._applyManipulationCallback(t, (t)=>{
                const i = q.getDataAttribute(t, e);
                null !== i ? (q.removeDataAttribute(t, e), t.style.setProperty(e, i)) : t.style.removeProperty(e);
            });
        }
        _applyManipulationCallback(t, e) {
            if (c(t)) e(t);
            else for (const i of V.find(t, this._element))e(i);
        }
    }
    const je = ".bs.modal", Fe = `hide${je}`, ze = `hidePrevented${je}`, He = `hidden${je}`, Be = `show${je}`, qe = `shown${je}`, We = `resize${je}`, Re = `click.dismiss${je}`, Ke = `mousedown.dismiss${je}`, Ve = `keydown.dismiss${je}`, Qe = `click${je}.data-api`, Xe = "modal-open", Ye = "show", Ue = "modal-static", Ge = {
        backdrop: !0,
        focus: !0,
        keyboard: !0
    }, Je = {
        backdrop: "(boolean|string)",
        focus: "boolean",
        keyboard: "boolean"
    };
    class Ze extends R {
        constructor(t, e){
            super(t, e), this._dialog = V.findOne(".modal-dialog", this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = !1, this._isTransitioning = !1, this._scrollBar = new Me, this._addEventListeners();
        }
        static get Default() {
            return Ge;
        }
        static get DefaultType() {
            return Je;
        }
        static get NAME() {
            return "modal";
        }
        toggle(t) {
            return this._isShown ? this.hide() : this.show(t);
        }
        show(t) {
            this._isShown || this._isTransitioning || F.trigger(this._element, Be, {
                relatedTarget: t
            }).defaultPrevented || (this._isShown = !0, this._isTransitioning = !0, this._scrollBar.hide(), document.body.classList.add(Xe), this._adjustDialog(), this._backdrop.show(()=>this._showElement(t)));
        }
        hide() {
            this._isShown && !this._isTransitioning && (F.trigger(this._element, Fe).defaultPrevented || (this._isShown = !1, this._isTransitioning = !0, this._focustrap.deactivate(), this._element.classList.remove(Ye), this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated())));
        }
        dispose() {
            F.off(window, je), F.off(this._dialog, je), this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
        }
        handleUpdate() {
            this._adjustDialog();
        }
        _initializeBackDrop() {
            return new Ce({
                isVisible: Boolean(this._config.backdrop),
                isAnimated: this._isAnimated()
            });
        }
        _initializeFocusTrap() {
            return new Ie({
                trapElement: this._element
            });
        }
        _showElement(t) {
            document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
            const e = V.findOne(".modal-body", this._dialog);
            e && (e.scrollTop = 0), f(this._element), this._element.classList.add(Ye), this._queueCallback(()=>{
                this._config.focus && this._focustrap.activate(), this._isTransitioning = !1, F.trigger(this._element, qe, {
                    relatedTarget: t
                });
            }, this._dialog, this._isAnimated());
        }
        _addEventListeners() {
            F.on(this._element, Ve, (t)=>{
                "Escape" === t.key && (this._config.keyboard ? this.hide() : this._triggerBackdropTransition());
            }), F.on(window, We, ()=>{
                this._isShown && !this._isTransitioning && this._adjustDialog();
            }), F.on(this._element, Ke, (t)=>{
                F.one(this._element, Re, (e)=>{
                    this._element === t.target && this._element === e.target && ("static" !== this._config.backdrop ? this._config.backdrop && this.hide() : this._triggerBackdropTransition());
                });
            });
        }
        _hideModal() {
            this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide(()=>{
                document.body.classList.remove(Xe), this._resetAdjustments(), this._scrollBar.reset(), F.trigger(this._element, He);
            });
        }
        _isAnimated() {
            return this._element.classList.contains("fade");
        }
        _triggerBackdropTransition() {
            if (F.trigger(this._element, ze).defaultPrevented) return;
            const t = this._element.scrollHeight > document.documentElement.clientHeight, e = this._element.style.overflowY;
            "hidden" === e || this._element.classList.contains(Ue) || (t || (this._element.style.overflowY = "hidden"), this._element.classList.add(Ue), this._queueCallback(()=>{
                this._element.classList.remove(Ue), this._queueCallback(()=>{
                    this._element.style.overflowY = e;
                }, this._dialog);
            }, this._dialog), this._element.focus());
        }
        _adjustDialog() {
            const t = this._element.scrollHeight > document.documentElement.clientHeight, e = this._scrollBar.getWidth(), i = e > 0;
            if (i && !t) {
                const t = b() ? "paddingLeft" : "paddingRight";
                this._element.style[t] = `${e}px`;
            }
            if (!i && t) {
                const t = b() ? "paddingRight" : "paddingLeft";
                this._element.style[t] = `${e}px`;
            }
        }
        _resetAdjustments() {
            this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
        }
        static jQueryInterface(t, e) {
            return this.each(function() {
                const i = Ze.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === i[t]) throw new TypeError(`No method named "${t}"`);
                    i[t](e);
                }
            });
        }
    }
    F.on(document, Qe, '[data-bs-toggle="modal"]', function(t) {
        const e = V.getElementFromSelector(this);
        [
            "A",
            "AREA"
        ].includes(this.tagName) && t.preventDefault(), F.one(e, Be, (t)=>{
            t.defaultPrevented || F.one(e, He, ()=>{
                d(this) && this.focus();
            });
        });
        const i = V.findOne(".modal.show");
        i && Ze.getInstance(i).hide(), Ze.getOrCreateInstance(e).toggle(this);
    }), Q(Ze), v(Ze);
    const ti = ".bs.offcanvas", ei = ".data-api", ii = `load${ti}${ei}`, si = "show", ni = "showing", oi = "hiding", ri = ".offcanvas.show", ai = `show${ti}`, li = `shown${ti}`, ci = `hide${ti}`, hi = `hidePrevented${ti}`, di = `hidden${ti}`, ui = `resize${ti}`, _i = `click${ti}${ei}`, gi = `keydown.dismiss${ti}`, fi = {
        backdrop: !0,
        keyboard: !0,
        scroll: !1
    }, mi = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        scroll: "boolean"
    };
    class pi extends R {
        constructor(t, e){
            super(t, e), this._isShown = !1, this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._addEventListeners();
        }
        static get Default() {
            return fi;
        }
        static get DefaultType() {
            return mi;
        }
        static get NAME() {
            return "offcanvas";
        }
        toggle(t) {
            return this._isShown ? this.hide() : this.show(t);
        }
        show(t) {
            this._isShown || F.trigger(this._element, ai, {
                relatedTarget: t
            }).defaultPrevented || (this._isShown = !0, this._backdrop.show(), this._config.scroll || (new Me).hide(), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.classList.add(ni), this._queueCallback(()=>{
                this._config.scroll && !this._config.backdrop || this._focustrap.activate(), this._element.classList.add(si), this._element.classList.remove(ni), F.trigger(this._element, li, {
                    relatedTarget: t
                });
            }, this._element, !0));
        }
        hide() {
            this._isShown && (F.trigger(this._element, ci).defaultPrevented || (this._focustrap.deactivate(), this._element.blur(), this._isShown = !1, this._element.classList.add(oi), this._backdrop.hide(), this._queueCallback(()=>{
                this._element.classList.remove(si, oi), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._config.scroll || (new Me).reset(), F.trigger(this._element, di);
            }, this._element, !0)));
        }
        dispose() {
            this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
        }
        _initializeBackDrop() {
            const t = Boolean(this._config.backdrop);
            return new Ce({
                className: "offcanvas-backdrop",
                isVisible: t,
                isAnimated: !0,
                rootElement: this._element.parentNode,
                clickCallback: t ? ()=>{
                    "static" !== this._config.backdrop ? this.hide() : F.trigger(this._element, hi);
                } : null
            });
        }
        _initializeFocusTrap() {
            return new Ie({
                trapElement: this._element
            });
        }
        _addEventListeners() {
            F.on(this._element, gi, (t)=>{
                "Escape" === t.key && (this._config.keyboard ? this.hide() : F.trigger(this._element, hi));
            });
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = pi.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError(`No method named "${t}"`);
                    e[t](this);
                }
            });
        }
    }
    F.on(document, _i, '[data-bs-toggle="offcanvas"]', function(t) {
        const e = V.getElementFromSelector(this);
        if ([
            "A",
            "AREA"
        ].includes(this.tagName) && t.preventDefault(), u(this)) return;
        F.one(e, di, ()=>{
            d(this) && this.focus();
        });
        const i = V.findOne(ri);
        i && i !== e && pi.getInstance(i).hide(), pi.getOrCreateInstance(e).toggle(this);
    }), F.on(window, ii, ()=>{
        for (const t of V.find(ri))pi.getOrCreateInstance(t).show();
    }), F.on(window, ui, ()=>{
        for (const t of V.find("[aria-modal][class*=show][class*=offcanvas-]"))"fixed" !== getComputedStyle(t).position && pi.getOrCreateInstance(t).hide();
    }), Q(pi), v(pi);
    const bi = {
        "*": [
            "class",
            "dir",
            "id",
            "lang",
            "role",
            /^aria-[\w-]*$/i
        ],
        a: [
            "target",
            "href",
            "title",
            "rel"
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        dd: [],
        div: [],
        dl: [],
        dt: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height"
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    }, vi = new Set([
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ]), yi = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, wi = (t, e)=>{
        const i = t.nodeName.toLowerCase();
        return e.includes(i) ? !vi.has(i) || Boolean(yi.test(t.nodeValue)) : e.filter((t)=>t instanceof RegExp).some((t)=>t.test(i));
    }, Ai = {
        allowList: bi,
        content: {},
        extraClass: "",
        html: !1,
        sanitize: !0,
        sanitizeFn: null,
        template: "<div></div>"
    }, Ei = {
        allowList: "object",
        content: "object",
        extraClass: "(string|function)",
        html: "boolean",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        template: "string"
    }, Ci = {
        entry: "(string|element|function|null)",
        selector: "(string|element)"
    };
    class Ti extends W {
        constructor(t){
            super(), this._config = this._getConfig(t);
        }
        static get Default() {
            return Ai;
        }
        static get DefaultType() {
            return Ei;
        }
        static get NAME() {
            return "TemplateFactory";
        }
        getContent() {
            return Object.values(this._config.content).map((t)=>this._resolvePossibleFunction(t)).filter(Boolean);
        }
        hasContent() {
            return this.getContent().length > 0;
        }
        changeContent(t) {
            return this._checkContent(t), this._config.content = {
                ...this._config.content,
                ...t
            }, this;
        }
        toHtml() {
            const t = document.createElement("div");
            t.innerHTML = this._maybeSanitize(this._config.template);
            for (const [e, i] of Object.entries(this._config.content))this._setContent(t, i, e);
            const e = t.children[0], i = this._resolvePossibleFunction(this._config.extraClass);
            return i && e.classList.add(...i.split(" ")), e;
        }
        _typeCheckConfig(t) {
            super._typeCheckConfig(t), this._checkContent(t.content);
        }
        _checkContent(t) {
            for (const [e, i] of Object.entries(t))super._typeCheckConfig({
                selector: e,
                entry: i
            }, Ci);
        }
        _setContent(t, e, i) {
            const s = V.findOne(i, t);
            s && ((e = this._resolvePossibleFunction(e)) ? c(e) ? this._putElementInTemplate(h(e), s) : this._config.html ? s.innerHTML = this._maybeSanitize(e) : s.textContent = e : s.remove());
        }
        _maybeSanitize(t) {
            return this._config.sanitize ? function(t, e, i) {
                if (!t.length) return t;
                if (i && "function" == typeof i) return i(t);
                const s = (new window.DOMParser).parseFromString(t, "text/html"), n = [].concat(...s.body.querySelectorAll("*"));
                for (const t of n){
                    const i = t.nodeName.toLowerCase();
                    if (!Object.keys(e).includes(i)) {
                        t.remove();
                        continue;
                    }
                    const s = [].concat(...t.attributes), n = [].concat(e["*"] || [], e[i] || []);
                    for (const e of s)wi(e, n) || t.removeAttribute(e.nodeName);
                }
                return s.body.innerHTML;
            }(t, this._config.allowList, this._config.sanitizeFn) : t;
        }
        _resolvePossibleFunction(t) {
            return y(t, [
                void 0,
                this
            ]);
        }
        _putElementInTemplate(t, e) {
            if (this._config.html) return e.innerHTML = "", void e.append(t);
            e.textContent = t.textContent;
        }
    }
    const ki = new Set([
        "sanitize",
        "allowList",
        "sanitizeFn"
    ]), $i = "fade", Si = "show", Li = ".tooltip-inner", Oi = ".modal", Ii = "hide.bs.modal", Di = "hover", Ni = "focus", Pi = "click", xi = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: b() ? "left" : "right",
        BOTTOM: "bottom",
        LEFT: b() ? "right" : "left"
    }, Mi = {
        allowList: bi,
        animation: !0,
        boundary: "clippingParents",
        container: !1,
        customClass: "",
        delay: 0,
        fallbackPlacements: [
            "top",
            "right",
            "bottom",
            "left"
        ],
        html: !1,
        offset: [
            0,
            6
        ],
        placement: "top",
        popperConfig: null,
        sanitize: !0,
        sanitizeFn: null,
        selector: !1,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        title: "",
        trigger: "hover focus"
    }, ji = {
        allowList: "object",
        animation: "boolean",
        boundary: "(string|element)",
        container: "(string|element|boolean)",
        customClass: "(string|function)",
        delay: "(number|object)",
        fallbackPlacements: "array",
        html: "boolean",
        offset: "(array|string|function)",
        placement: "(string|function)",
        popperConfig: "(null|object|function)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        selector: "(string|boolean)",
        template: "string",
        title: "(string|element|function)",
        trigger: "string"
    };
    class Fi extends R {
        constructor(t, e){
            if (void 0 === i) throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org/docs/v2/)");
            super(t, e), this._isEnabled = !0, this._timeout = 0, this._isHovered = null, this._activeTrigger = {}, this._popper = null, this._templateFactory = null, this._newContent = null, this.tip = null, this._setListeners(), this._config.selector || this._fixTitle();
        }
        static get Default() {
            return Mi;
        }
        static get DefaultType() {
            return ji;
        }
        static get NAME() {
            return "tooltip";
        }
        enable() {
            this._isEnabled = !0;
        }
        disable() {
            this._isEnabled = !1;
        }
        toggleEnabled() {
            this._isEnabled = !this._isEnabled;
        }
        toggle() {
            this._isEnabled && (this._isShown() ? this._leave() : this._enter());
        }
        dispose() {
            clearTimeout(this._timeout), F.off(this._element.closest(Oi), Ii, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), super.dispose();
        }
        show() {
            if ("none" === this._element.style.display) throw new Error("Please use show on visible elements");
            if (!this._isWithContent() || !this._isEnabled) return;
            const t = F.trigger(this._element, this.constructor.eventName("show")), e = (_(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
            if (t.defaultPrevented || !e) return;
            this._disposePopper();
            const i = this._getTipElement();
            this._element.setAttribute("aria-describedby", i.getAttribute("id"));
            const { container: s } = this._config;
            if (this._element.ownerDocument.documentElement.contains(this.tip) || (s.append(i), F.trigger(this._element, this.constructor.eventName("inserted"))), this._popper = this._createPopper(i), i.classList.add(Si), "ontouchstart" in document.documentElement) for (const t of [].concat(...document.body.children))F.on(t, "mouseover", g);
            this._queueCallback(()=>{
                F.trigger(this._element, this.constructor.eventName("shown")), !1 === this._isHovered && this._leave(), this._isHovered = !1;
            }, this.tip, this._isAnimated());
        }
        hide() {
            if (this._isShown() && !F.trigger(this._element, this.constructor.eventName("hide")).defaultPrevented) {
                if (this._getTipElement().classList.remove(Si), "ontouchstart" in document.documentElement) for (const t of [].concat(...document.body.children))F.off(t, "mouseover", g);
                this._activeTrigger[Pi] = !1, this._activeTrigger[Ni] = !1, this._activeTrigger[Di] = !1, this._isHovered = null, this._queueCallback(()=>{
                    this._isWithActiveTrigger() || (this._isHovered || this._disposePopper(), this._element.removeAttribute("aria-describedby"), F.trigger(this._element, this.constructor.eventName("hidden")));
                }, this.tip, this._isAnimated());
            }
        }
        update() {
            this._popper && this._popper.update();
        }
        _isWithContent() {
            return Boolean(this._getTitle());
        }
        _getTipElement() {
            return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
        }
        _createTipElement(t) {
            const e = this._getTemplateFactory(t).toHtml();
            if (!e) return null;
            e.classList.remove($i, Si), e.classList.add(`bs-${this.constructor.NAME}-auto`);
            const i = ((t)=>{
                do t += Math.floor(1e6 * Math.random());
                while (document.getElementById(t));
                return t;
            })(this.constructor.NAME).toString();
            return e.setAttribute("id", i), this._isAnimated() && e.classList.add($i), e;
        }
        setContent(t) {
            this._newContent = t, this._isShown() && (this._disposePopper(), this.show());
        }
        _getTemplateFactory(t) {
            return this._templateFactory ? this._templateFactory.changeContent(t) : this._templateFactory = new Ti({
                ...this._config,
                content: t,
                extraClass: this._resolvePossibleFunction(this._config.customClass)
            }), this._templateFactory;
        }
        _getContentForTemplate() {
            return {
                [Li]: this._getTitle()
            };
        }
        _getTitle() {
            return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
        }
        _initializeOnDelegatedTarget(t) {
            return this.constructor.getOrCreateInstance(t.delegateTarget, this._getDelegateConfig());
        }
        _isAnimated() {
            return this._config.animation || this.tip && this.tip.classList.contains($i);
        }
        _isShown() {
            return this.tip && this.tip.classList.contains(Si);
        }
        _createPopper(t) {
            const e = y(this._config.placement, [
                this,
                t,
                this._element
            ]), s = xi[e.toUpperCase()];
            return i.createPopper(this._element, t, this._getPopperConfig(s));
        }
        _getOffset() {
            const { offset: t } = this._config;
            return "string" == typeof t ? t.split(",").map((t)=>Number.parseInt(t, 10)) : "function" == typeof t ? (e)=>t(e, this._element) : t;
        }
        _resolvePossibleFunction(t) {
            return y(t, [
                this._element,
                this._element
            ]);
        }
        _getPopperConfig(t) {
            const e = {
                placement: t,
                modifiers: [
                    {
                        name: "flip",
                        options: {
                            fallbackPlacements: this._config.fallbackPlacements
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: this._getOffset()
                        }
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: "arrow",
                        options: {
                            element: `.${this.constructor.NAME}-arrow`
                        }
                    },
                    {
                        name: "preSetPlacement",
                        enabled: !0,
                        phase: "beforeMain",
                        fn: (t)=>{
                            this._getTipElement().setAttribute("data-popper-placement", t.state.placement);
                        }
                    }
                ]
            };
            return {
                ...e,
                ...y(this._config.popperConfig, [
                    void 0,
                    e
                ])
            };
        }
        _setListeners() {
            const t = this._config.trigger.split(" ");
            for (const e of t)if ("click" === e) F.on(this._element, this.constructor.eventName("click"), this._config.selector, (t)=>{
                const e = this._initializeOnDelegatedTarget(t);
                e._activeTrigger[Pi] = !(e._isShown() && e._activeTrigger[Pi]), e.toggle();
            });
            else if ("manual" !== e) {
                const t = e === Di ? this.constructor.eventName("mouseenter") : this.constructor.eventName("focusin"), i = e === Di ? this.constructor.eventName("mouseleave") : this.constructor.eventName("focusout");
                F.on(this._element, t, this._config.selector, (t)=>{
                    const e = this._initializeOnDelegatedTarget(t);
                    e._activeTrigger["focusin" === t.type ? Ni : Di] = !0, e._enter();
                }), F.on(this._element, i, this._config.selector, (t)=>{
                    const e = this._initializeOnDelegatedTarget(t);
                    e._activeTrigger["focusout" === t.type ? Ni : Di] = e._element.contains(t.relatedTarget), e._leave();
                });
            }
            this._hideModalHandler = ()=>{
                this._element && this.hide();
            }, F.on(this._element.closest(Oi), Ii, this._hideModalHandler);
        }
        _fixTitle() {
            const t = this._element.getAttribute("title");
            t && (this._element.getAttribute("aria-label") || this._element.textContent.trim() || this._element.setAttribute("aria-label", t), this._element.setAttribute("data-bs-original-title", t), this._element.removeAttribute("title"));
        }
        _enter() {
            this._isShown() || this._isHovered ? this._isHovered = !0 : (this._isHovered = !0, this._setTimeout(()=>{
                this._isHovered && this.show();
            }, this._config.delay.show));
        }
        _leave() {
            this._isWithActiveTrigger() || (this._isHovered = !1, this._setTimeout(()=>{
                this._isHovered || this.hide();
            }, this._config.delay.hide));
        }
        _setTimeout(t, e) {
            clearTimeout(this._timeout), this._timeout = setTimeout(t, e);
        }
        _isWithActiveTrigger() {
            return Object.values(this._activeTrigger).includes(!0);
        }
        _getConfig(t) {
            const e = q.getDataAttributes(this._element);
            for (const t of Object.keys(e))ki.has(t) && delete e[t];
            return t = {
                ...e,
                ..."object" == typeof t && t ? t : {}
            }, t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
        }
        _configAfterMerge(t) {
            return t.container = !1 === t.container ? document.body : h(t.container), "number" == typeof t.delay && (t.delay = {
                show: t.delay,
                hide: t.delay
            }), "number" == typeof t.title && (t.title = t.title.toString()), "number" == typeof t.content && (t.content = t.content.toString()), t;
        }
        _getDelegateConfig() {
            const t = {};
            for (const [e, i] of Object.entries(this._config))this.constructor.Default[e] !== i && (t[e] = i);
            return t.selector = !1, t.trigger = "manual", t;
        }
        _disposePopper() {
            this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = Fi.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t]();
                }
            });
        }
    }
    v(Fi);
    const zi = ".popover-header", Hi = ".popover-body", Bi = {
        ...Fi.Default,
        content: "",
        offset: [
            0,
            8
        ],
        placement: "right",
        template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
        trigger: "click"
    }, qi = {
        ...Fi.DefaultType,
        content: "(null|string|element|function)"
    };
    class Wi extends Fi {
        static get Default() {
            return Bi;
        }
        static get DefaultType() {
            return qi;
        }
        static get NAME() {
            return "popover";
        }
        _isWithContent() {
            return this._getTitle() || this._getContent();
        }
        _getContentForTemplate() {
            return {
                [zi]: this._getTitle(),
                [Hi]: this._getContent()
            };
        }
        _getContent() {
            return this._resolvePossibleFunction(this._config.content);
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = Wi.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t]();
                }
            });
        }
    }
    v(Wi);
    const Ri = ".bs.scrollspy", Ki = `activate${Ri}`, Vi = `click${Ri}`, Qi = `load${Ri}.data-api`, Xi = "active", Yi = "[href]", Ui = ".nav-link", Gi = `${Ui}, .nav-item > ${Ui}, .list-group-item`, Ji = {
        offset: null,
        rootMargin: "0px 0px -25%",
        smoothScroll: !1,
        target: null,
        threshold: [
            .1,
            .5,
            1
        ]
    }, Zi = {
        offset: "(number|null)",
        rootMargin: "string",
        smoothScroll: "boolean",
        target: "element",
        threshold: "array"
    };
    class ts extends R {
        constructor(t, e){
            super(t, e), this._targetLinks = new Map, this._observableSections = new Map, this._rootElement = "visible" === getComputedStyle(this._element).overflowY ? null : this._element, this._activeTarget = null, this._observer = null, this._previousScrollData = {
                visibleEntryTop: 0,
                parentScrollTop: 0
            }, this.refresh();
        }
        static get Default() {
            return Ji;
        }
        static get DefaultType() {
            return Zi;
        }
        static get NAME() {
            return "scrollspy";
        }
        refresh() {
            this._initializeTargetsAndObservables(), this._maybeEnableSmoothScroll(), this._observer ? this._observer.disconnect() : this._observer = this._getNewObserver();
            for (const t of this._observableSections.values())this._observer.observe(t);
        }
        dispose() {
            this._observer.disconnect(), super.dispose();
        }
        _configAfterMerge(t) {
            return t.target = h(t.target) || document.body, t.rootMargin = t.offset ? `${t.offset}px 0px -30%` : t.rootMargin, "string" == typeof t.threshold && (t.threshold = t.threshold.split(",").map((t)=>Number.parseFloat(t))), t;
        }
        _maybeEnableSmoothScroll() {
            this._config.smoothScroll && (F.off(this._config.target, Vi), F.on(this._config.target, Vi, Yi, (t)=>{
                const e = this._observableSections.get(t.target.hash);
                if (e) {
                    t.preventDefault();
                    const i = this._rootElement || window, s = e.offsetTop - this._element.offsetTop;
                    if (i.scrollTo) return void i.scrollTo({
                        top: s,
                        behavior: "smooth"
                    });
                    i.scrollTop = s;
                }
            }));
        }
        _getNewObserver() {
            const t = {
                root: this._rootElement,
                threshold: this._config.threshold,
                rootMargin: this._config.rootMargin
            };
            return new IntersectionObserver((t)=>this._observerCallback(t), t);
        }
        _observerCallback(t) {
            const e = (t)=>this._targetLinks.get(`#${t.target.id}`), i = (t)=>{
                this._previousScrollData.visibleEntryTop = t.target.offsetTop, this._process(e(t));
            }, s = (this._rootElement || document.documentElement).scrollTop, n = s >= this._previousScrollData.parentScrollTop;
            this._previousScrollData.parentScrollTop = s;
            for (const o of t){
                if (!o.isIntersecting) {
                    this._activeTarget = null, this._clearActiveClass(e(o));
                    continue;
                }
                const t = o.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                if (n && t) {
                    if (i(o), !s) return;
                } else n || t || i(o);
            }
        }
        _initializeTargetsAndObservables() {
            this._targetLinks = new Map, this._observableSections = new Map;
            const t = V.find(Yi, this._config.target);
            for (const e of t){
                if (!e.hash || u(e)) continue;
                const t = V.findOne(decodeURI(e.hash), this._element);
                d(t) && (this._targetLinks.set(decodeURI(e.hash), e), this._observableSections.set(e.hash, t));
            }
        }
        _process(t) {
            this._activeTarget !== t && (this._clearActiveClass(this._config.target), this._activeTarget = t, t.classList.add(Xi), this._activateParents(t), F.trigger(this._element, Ki, {
                relatedTarget: t
            }));
        }
        _activateParents(t) {
            if (t.classList.contains("dropdown-item")) V.findOne(".dropdown-toggle", t.closest(".dropdown")).classList.add(Xi);
            else for (const e of V.parents(t, ".nav, .list-group"))for (const t of V.prev(e, Gi))t.classList.add(Xi);
        }
        _clearActiveClass(t) {
            t.classList.remove(Xi);
            const e = V.find(`${Yi}.${Xi}`, t);
            for (const t of e)t.classList.remove(Xi);
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = ts.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError(`No method named "${t}"`);
                    e[t]();
                }
            });
        }
    }
    F.on(window, Qi, ()=>{
        for (const t of V.find('[data-bs-spy="scroll"]'))ts.getOrCreateInstance(t);
    }), v(ts);
    const es = ".bs.tab", is = `hide${es}`, ss = `hidden${es}`, ns = `show${es}`, os = `shown${es}`, rs = `click${es}`, as = `keydown${es}`, ls = `load${es}`, cs = "ArrowLeft", hs = "ArrowRight", ds = "ArrowUp", us = "ArrowDown", _s = "Home", gs = "End", fs = "active", ms = "fade", ps = "show", bs = ".dropdown-toggle", vs = `:not(${bs})`, ys = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', ws = `.nav-link${vs}, .list-group-item${vs}, [role="tab"]${vs}, ${ys}`, As = `.${fs}[data-bs-toggle="tab"], .${fs}[data-bs-toggle="pill"], .${fs}[data-bs-toggle="list"]`;
    class Es extends R {
        constructor(t){
            super(t), this._parent = this._element.closest('.list-group, .nav, [role="tablist"]'), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), F.on(this._element, as, (t)=>this._keydown(t)));
        }
        static get NAME() {
            return "tab";
        }
        show() {
            const t = this._element;
            if (this._elemIsActive(t)) return;
            const e = this._getActiveElem(), i = e ? F.trigger(e, is, {
                relatedTarget: t
            }) : null;
            F.trigger(t, ns, {
                relatedTarget: e
            }).defaultPrevented || i && i.defaultPrevented || (this._deactivate(e, t), this._activate(t, e));
        }
        _activate(t, e) {
            t && (t.classList.add(fs), this._activate(V.getElementFromSelector(t)), this._queueCallback(()=>{
                "tab" === t.getAttribute("role") ? (t.removeAttribute("tabindex"), t.setAttribute("aria-selected", !0), this._toggleDropDown(t, !0), F.trigger(t, os, {
                    relatedTarget: e
                })) : t.classList.add(ps);
            }, t, t.classList.contains(ms)));
        }
        _deactivate(t, e) {
            t && (t.classList.remove(fs), t.blur(), this._deactivate(V.getElementFromSelector(t)), this._queueCallback(()=>{
                "tab" === t.getAttribute("role") ? (t.setAttribute("aria-selected", !1), t.setAttribute("tabindex", "-1"), this._toggleDropDown(t, !1), F.trigger(t, ss, {
                    relatedTarget: e
                })) : t.classList.remove(ps);
            }, t, t.classList.contains(ms)));
        }
        _keydown(t) {
            if (![
                cs,
                hs,
                ds,
                us,
                _s,
                gs
            ].includes(t.key)) return;
            t.stopPropagation(), t.preventDefault();
            const e = this._getChildren().filter((t)=>!u(t));
            let i;
            if ([
                _s,
                gs
            ].includes(t.key)) i = e[t.key === _s ? 0 : e.length - 1];
            else {
                const s = [
                    hs,
                    us
                ].includes(t.key);
                i = A(e, t.target, s, !0);
            }
            i && (i.focus({
                preventScroll: !0
            }), Es.getOrCreateInstance(i).show());
        }
        _getChildren() {
            return V.find(ws, this._parent);
        }
        _getActiveElem() {
            return this._getChildren().find((t)=>this._elemIsActive(t)) || null;
        }
        _setInitialAttributes(t, e) {
            this._setAttributeIfNotExists(t, "role", "tablist");
            for (const t of e)this._setInitialAttributesOnChild(t);
        }
        _setInitialAttributesOnChild(t) {
            t = this._getInnerElement(t);
            const e = this._elemIsActive(t), i = this._getOuterElement(t);
            t.setAttribute("aria-selected", e), i !== t && this._setAttributeIfNotExists(i, "role", "presentation"), e || t.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(t, "role", "tab"), this._setInitialAttributesOnTargetPanel(t);
        }
        _setInitialAttributesOnTargetPanel(t) {
            const e = V.getElementFromSelector(t);
            e && (this._setAttributeIfNotExists(e, "role", "tabpanel"), t.id && this._setAttributeIfNotExists(e, "aria-labelledby", `${t.id}`));
        }
        _toggleDropDown(t, e) {
            const i = this._getOuterElement(t);
            if (!i.classList.contains("dropdown")) return;
            const s = (t, s)=>{
                const n = V.findOne(t, i);
                n && n.classList.toggle(s, e);
            };
            s(bs, fs), s(".dropdown-menu", ps), i.setAttribute("aria-expanded", e);
        }
        _setAttributeIfNotExists(t, e, i) {
            t.hasAttribute(e) || t.setAttribute(e, i);
        }
        _elemIsActive(t) {
            return t.classList.contains(fs);
        }
        _getInnerElement(t) {
            return t.matches(ws) ? t : V.findOne(ws, t);
        }
        _getOuterElement(t) {
            return t.closest(".nav-item, .list-group-item") || t;
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = Es.getOrCreateInstance(this);
                if ("string" == typeof t) {
                    if (void 0 === e[t] || t.startsWith("_") || "constructor" === t) throw new TypeError(`No method named "${t}"`);
                    e[t]();
                }
            });
        }
    }
    F.on(document, rs, ys, function(t) {
        [
            "A",
            "AREA"
        ].includes(this.tagName) && t.preventDefault(), u(this) || Es.getOrCreateInstance(this).show();
    }), F.on(window, ls, ()=>{
        for (const t of V.find(As))Es.getOrCreateInstance(t);
    }), v(Es);
    const Cs = ".bs.toast", Ts = `mouseover${Cs}`, ks = `mouseout${Cs}`, $s = `focusin${Cs}`, Ss = `focusout${Cs}`, Ls = `hide${Cs}`, Os = `hidden${Cs}`, Is = `show${Cs}`, Ds = `shown${Cs}`, Ns = "hide", Ps = "show", xs = "showing", Ms = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    }, js = {
        animation: !0,
        autohide: !0,
        delay: 5e3
    };
    class Fs extends R {
        constructor(t, e){
            super(t, e), this._timeout = null, this._hasMouseInteraction = !1, this._hasKeyboardInteraction = !1, this._setListeners();
        }
        static get Default() {
            return js;
        }
        static get DefaultType() {
            return Ms;
        }
        static get NAME() {
            return "toast";
        }
        show() {
            F.trigger(this._element, Is).defaultPrevented || (this._clearTimeout(), this._config.animation && this._element.classList.add("fade"), this._element.classList.remove(Ns), f(this._element), this._element.classList.add(Ps, xs), this._queueCallback(()=>{
                this._element.classList.remove(xs), F.trigger(this._element, Ds), this._maybeScheduleHide();
            }, this._element, this._config.animation));
        }
        hide() {
            this.isShown() && (F.trigger(this._element, Ls).defaultPrevented || (this._element.classList.add(xs), this._queueCallback(()=>{
                this._element.classList.add(Ns), this._element.classList.remove(xs, Ps), F.trigger(this._element, Os);
            }, this._element, this._config.animation)));
        }
        dispose() {
            this._clearTimeout(), this.isShown() && this._element.classList.remove(Ps), super.dispose();
        }
        isShown() {
            return this._element.classList.contains(Ps);
        }
        _maybeScheduleHide() {
            this._config.autohide && (this._hasMouseInteraction || this._hasKeyboardInteraction || (this._timeout = setTimeout(()=>{
                this.hide();
            }, this._config.delay)));
        }
        _onInteraction(t, e) {
            switch(t.type){
                case "mouseover":
                case "mouseout":
                    this._hasMouseInteraction = e;
                    break;
                case "focusin":
                case "focusout":
                    this._hasKeyboardInteraction = e;
            }
            if (e) return void this._clearTimeout();
            const i = t.relatedTarget;
            this._element === i || this._element.contains(i) || this._maybeScheduleHide();
        }
        _setListeners() {
            F.on(this._element, Ts, (t)=>this._onInteraction(t, !0)), F.on(this._element, ks, (t)=>this._onInteraction(t, !1)), F.on(this._element, $s, (t)=>this._onInteraction(t, !0)), F.on(this._element, Ss, (t)=>this._onInteraction(t, !1));
        }
        _clearTimeout() {
            clearTimeout(this._timeout), this._timeout = null;
        }
        static jQueryInterface(t) {
            return this.each(function() {
                const e = Fs.getOrCreateInstance(this, t);
                if ("string" == typeof t) {
                    if (void 0 === e[t]) throw new TypeError(`No method named "${t}"`);
                    e[t](this);
                }
            });
        }
    }
    return Q(Fs), v(Fs), {
        Alert: G,
        Button: Z,
        Carousel: Nt,
        Collapse: Qt,
        Dropdown: be,
        Modal: Ze,
        Offcanvas: pi,
        Popover: Wi,
        ScrollSpy: ts,
        Tab: Es,
        Toast: Fs,
        Tooltip: Fi
    };
});


//# sourceMappingURL=examples.d5d80c2a.js.map
